// src/translations.js
const translations = {
  de: {

    // ======================
    // Regionsseite Schweiz (/auto-verkaufen-schweiz)
    // ======================
    chpage: {
      meta_title: "Auto verkaufen in der Schweiz | Ankauf und Verzollung | AUTO M.A.H.",
      meta_desc: "Sie wollen Ihr Auto in der Schweiz verkaufen? Ich kaufe an und mache Ausfuhr und Verzollung selbst. Unverbindliche Bewertung, Region Basel, Aargau, Solothurn, Bern und Zürich.",
      h1: "Auto verkaufen in der Schweiz",
      lead: "Ihr Auto steht in der Schweiz und Sie wollen es verkaufen. Ich kaufe es an und hole es ab. Den Weg über die Grenze mache ich.",
      cta: "Fahrzeug anbieten",
      cta_hint: "Unverbindlich und kostenlos. Sie gehen mit der Anfrage keine Verpflichtung ein.",

      why_title: "Warum an mich verkaufen",
      why1_title: "Die Verzollung mache ich selbst",
      why1_text: "Ich gebe die Zollabfertigung nicht an eine Spedition ab. Weil ich sie für meine eigenen Fahrzeuge laufend mache, kenne ich die Bestimmungen und die nötigen Papiere aus der Praxis.",
      why2_title: "Der Weg ist kurz",
      why2_text: "Ich sitze in Steinen im Dreiländereck, direkt an der Grenze. Von hier bin ich schnell bei Ihnen.",
      why3_title: "Seit 2007 im Autohandel",
      why3_text: "Ich bin seit 2007 selbständig im Autohandel und kein Zwischenhändler, der Ihr Auto erst weitersucht.",
      why4_title: "Erst schauen, dann entscheiden",
      why4_text: "Bis wir uns nach der Besichtigung einig sind, ist alles unverbindlich und kostenlos.",

      zoll_title: "Was der Zoll damit zu tun hat",
      zoll_p1: "Die Schweiz ist zollrechtlich ein Drittland. Wenn ein Fahrzeug von dort nach Deutschland kommt, fallen in der Regel 10 Prozent Zoll und 19 Prozent Einfuhrumsatzsteuer an.",
      zoll_p2: "Das ist der Punkt, an dem viele Käufer aus Deutschland abspringen. Bei mir ist es Alltag: ich melde das Fahrzeug selbst an und führe es ein. Für Sie als Verkäufer ändert sich dadurch nichts am Ablauf.",
      zoll_hinweis: "Allgemeine Auskunft nach bestem Wissen, keine Rechts- oder Steuerberatung. Der Einzelfall kann abweichen, fragen Sie mich einfach.",

      ablauf_title: "So läuft es ab",
      area_title: "Wo ich in der Schweiz ankaufe",
      area_lead: "Weiter entfernt ist kein Problem, sprechen Sie mich an.",
      area_list: ["Region Basel", "Kanton Aargau", "Kanton Solothurn", "Kanton Bern", "Kanton Zürich"],

      was_title: "Was Sie brauchen",
      was_lead: "Kurz gesagt: sehr wenig. Den größten Teil übernehme ich.",
      sie_title: "Bei einem Schweizer Fahrzeug brauchen Sie",
      was1_title: "Fahrzeugausweis",
      was1_text: "Das ist das Einzige, was Sie selbst bereithalten müssen.",
      was2_title: "Kaufvertrag",
      was2_text: "Den machen wir zusammen, sobald wir uns über den Preis einig sind.",
      andere_text: "Anderer Fall? Ein deutsches Fahrzeug, das in der Schweiz steht, ein Firmenwagen oder ein Händlerfahrzeug: melden Sie sich, den Weg kenne ich auch.",
      rest_title: "Das übernehme ich",
      rest1_title: "Annullieren",
      rest1_text: "Das Abmelden des Fahrzeugs erledige ich.",
      rest2_title: "Transport",
      rest2_text: "Ich komme mit einem Transporter und hole das Fahrzeug bei Ihnen ab. Sie müssen nirgendwo hinfahren.",
      rest3_title: "Einfuhr nach Deutschland",
      rest3_text: "Ausfuhr, Verzollung und Einfuhr sind mein Teil. Damit haben Sie nichts zu tun.",
      schluss_title: "Sie haben ein Fahrzeug?",
      schluss_text: "Schicken Sie mir die Eckdaten und ein paar Fotos. Ich melde mich mit einer ehrlichen Einschätzung zurück.",
    },
    // Navigation (falls du sie global brauchst)
    nav_home: "Start",
    nav_services: "Leistungen",
    nav_purchase: "Fahrzeug Ankauf",
    nav_cars: "Fahrzeuge",
    nav_cta: "Auto verkaufen",
    nav_about: "Über mich",
    nav_contact: "Kontakt",

    global: {
      demo_submit_info:
        "Danke! Ihre Anfrage wurde erfasst (Demo). Bitte Backend anbinden.",
    },

    nf: {
      titel: "Diese Seite gibt es nicht",
      text: "Der Link führt ins Leere. Vielleicht ein Tippfehler, vielleicht eine alte Adresse.",
      start: "Zur Startseite",
      hilfe: "Sie suchen etwas Bestimmtes? Rufen Sie mich an:",
    },
    hero: {
      title: "Autoankauf und Import in Deutschland, der Schweiz und Frankreich",
      subtitle:
        "Direkt im Dreiländereck • Ankauf DE · CH · FR • Verzollung • Zulassung • EU-Export",
      cta: "Jetzt Ankauf anfragen",
      cta_whatsapp: "WhatsApp",
      whatsapp_text: "Hallo, ich möchte mein Auto verkaufen.",
      cta_anruf: "Anrufen",
      schliessen: "Schließen",
      badge_fair: "Faire Preise",
      badge_fast: "Schnelle Abwicklung",
      badge_pro: "Eigene Zollabfertigung",
      badge_wish: "Wunschauto-Service",
    },

    services: {
      title: "Meine Leistungen",
      card1: {
        title: "Fahrzeugankauf Deutschland, Schweiz & Frankreich",
        text: "Ich kaufe qualitativ hochwertige Fahrzeuge direkt auf dem deutschen, Schweizer und französischen Markt an - faire Preise, schnelle Abwicklung",
      },
      card2: {
        title: "Import & Verzollung",
        text: "Meine Fahrzeuge aus der Schweiz führe ich selbst ein und verzolle sie, nicht über eine Spedition. Sie kaufen ein fertig eingeführtes Auto.",
      },
      card3: {
        title: "Deutsche Zulassung & TÜV-Abnahme",
        text: "Service und TÜV Hauptuntersuchung - fahrzeugfertig für den Verkauf",
      },
      card4: {
        title: "Handel & Vertrieb",
        text: "Verkauf der importierten Fahrzeuge auf dem deutschen Markt oder Export in EU-Länder",
      },
      card5: {
        title: "Wunschauto-Service",
        text: "Sie suchen ein bestimmtes Fahrzeug? Ich finde es nach Ihren Vorgaben - Marke, Ausstattung, Budget. National und international.",
      },
      card6: {
        title: "Individuelle Fahrzeugsuche",
        text: "Gezielte Suche nach Ihrem Traumauto mit spezifischen Ausstattungswünschen und Budgetvorgaben",
      },
    },

    faq: {
      title: "Häufige Fragen",
      subtitle: "Was Käufer und Verkäufer mich am häufigsten fragen.",
      hinweis: "Allgemeine Auskunft nach bestem Wissen, keine Rechts- oder Steuerberatung. Der Einzelfall kann abweichen, fragen Sie mich einfach.",
      q1: "Sind Ihre Fahrzeuge aus der Schweiz ordnungsgemäß eingeführt?",
      a1: "Ja. Die Schweiz ist zollrechtlich ein Drittland, in der Regel fallen 10 % Zoll und 19 % Einfuhrumsatzsteuer an. Die Verzollung mache ich selbst und nicht über eine Spedition. Ein Fahrzeug gebe ich erst weiter, wenn die Einfuhr abgeschlossen ist und die Zollpapiere vorliegen.",
      q2: "Was bedeutet das für mich als Käufer?",
      a2: "Sie bekommen ein Fahrzeug, bei dem die Einfuhr erledigt ist und die Papiere vollständig sind. Was für die Zulassung nötig ist, gehe ich vorher mit Ihnen durch, ebenso den Stand von Haupt- und Abgasuntersuchung. Für Ihr Fahrzeug halten wir das schriftlich fest.",
      q3: "Verkaufen Sie auch an Händler oder ins EU-Ausland?",
      a3: "Ja. Ich verkaufe an Privatkunden in Deutschland, an Händler und exportiere in andere EU-Länder. Sprechen Sie mich auf Ihren Fall an, für Händler und Export gelten eigene Konditionen.",
      q4: "Ich möchte mein Auto verkaufen. Wie läuft das?",
      a4: "Sie schicken mir die Eckdaten und ein paar Fotos, über das Formular, per WhatsApp oder Telefon. Ich melde mich mit einer ehrlichen Einschätzung. Erst wenn wir uns nach der Besichtigung einig sind, wird daraus ein Geschäft. Bis dahin ist alles unverbindlich und kostenlos.",
      q5: "Ich verkaufe aus der Schweiz. Was muss ich tun?",
      a5: "Sie brauchen nur den Fahrzeugausweis, den Kaufvertrag machen wir zusammen. Das Annullieren, den Transport und die Einfuhr nach Deutschland übernehme ich. Sie müssen nirgendwo hinfahren.",
      a5_link: "Alles dazu: Auto verkaufen in der Schweiz",
    },

    ablauf: {
      title: "Sie wollen Ihr Auto verkaufen?",
      subtitle: "So läuft der Ankauf ab. Vier Schritte, kein Risiko: bis zur Einigung ist alles unverbindlich.",
      s1_title: "Anfrage senden",
      s1_text: "Über das Formular, per WhatsApp oder Telefon. Fotos helfen mir bei der Einschätzung. Unverbindlich und kostenlos.",
      s2_title: "Bewertung erhalten",
      s2_text: "Ich schaue mir die Angaben an und melde mich mit einer ehrlichen Einschätzung und einem Preisvorschlag zurück.",
      s3_title: "Besichtigung & Einigung",
      s3_text: "Wir schauen uns das Fahrzeug gemeinsam an. Erst wenn wir uns einig sind, wird aus der Anfrage ein Geschäft.",
      s4_title: "Verkauf & Übergabe",
      s4_text: "Wir werden uns einig, Sie bekommen Ihr Geld und ich übernehme das Fahrzeug samt Papieren. Alles Weitere ist meine Sache.",
    },

    purchase: {
      title: "Fahrzeug Ankauf & Vermittlung",
      subtitle:
        "Ich kaufe Ihr Fahrzeug direkt an oder helfe bei der Suche nach Ihrem Wunschauto",
      offer_two_services: "Ich biete zwei Leistungen an:",
      feature_buy: {
        title: "Fahrzeugankauf",
        text: "Ich kaufe Ihr Auto zu fairen Konditionen",
      },
      feature_wish: {
        title: "Wunschauto-Service",
        text: "Ich finde Ihr Traumauto nach Ihren Vorgaben",
      },
      feature_note:
        "Egal ob Verkauf oder Kauf - ich mache Ihnen ein faires Angebot und finde Ihr Wunschfahrzeug!",

      accept_all_title: "Ich kaufe Gebrauchtwagen aller Automarken und Modelle",
      accept_high_mileage: "Auch mit hohen Kilometerzahlen",
      accept_defects: "Fahrzeuge mit Defekten oder Schäden",
      accept_accident: "Unfallfahrzeuge",
      accept_total_loss: "Wirtschaftliche Totalschäden",
      accept_young_old: "Junge und alte Fahrzeuge",
      accept_luxury_daily: "Luxusfahrzeuge & Alltagsautos",
      accept_with_without_history: "Mit oder ohne Service-Historie",
      fair_offer_any_condition:
        "Egal in welchem Zustand - ich mache Ihnen ein faires Angebot!",
    },

    cars: {
      title: "Aktuelle Fahrzeuge",
      lead: "Wenn Sie ein Auto suchen, fragen Sie mich. Den Preis sage ich Ihnen persönlich. Gekauft wird bei mir, nicht über die Seite.",
      price: "Preis auf Anfrage",
      btn: "Nachfragen",
      open: "Fahrzeuge ansehen",
      soon: "Noch keine Autos hier",
      soon_text: "Im Moment steht nichts auf der Seite. Wenn Sie etwas Bestimmtes suchen, schreiben Sie mir. Ich schaue, was ich finden kann.",
      anfrage_text: "Anfrage zum Fahrzeug: {auto}",
    },

    about: {
      title: "Über AUTO M.A.H.",
      owner_alt: "Inhaber AUTO M.A.H.",
      owner_name: "Mohamed Ali Hussein",
      owner_role: "Inhaber & Geschäftsführer",
      qr_text: "FOTO SENDEN · ANGEBOT ERHALTEN",
      headline:
        "Ihr Spezialist für Fahrzeugankauf und Import im Dreiländereck Deutschland, Schweiz und Frankreich",
      p1: "Seit 2007 bin ich selbständig im Autohandel. Heute sitze ich in Steinen, direkt im Dreiländereck. Von hier komme ich schnell nach Deutschland, in die Schweiz und nach Frankreich. Autos aus der Schweiz verzolle ich nach deutschen Regeln und verkaufe sie danach in Deutschland oder in die EU.",
      p2: "Die Zollabfertigung übernehme ich selbst und gebe sie nicht an eine Spedition ab. Weil ich sie für meine eigenen Fahrzeuge laufend mache, kenne ich die deutschen Bestimmungen und die nötigen Papiere aus der Praxis, nicht aus dem Lehrbuch. Das macht den Weg von der Schweiz nach Deutschland kurz und planbar.",
      new_wish_service_title: "Wunschauto-Service",
      new_wish_service_text:
        "Sie suchen ein bestimmtes Auto mit einer bestimmten Ausstattung? Ich suche es für Sie, bei uns und im Ausland.",
      note_strong:
        "Sie haben Fragen zum Autoimport oder suchen ein bestimmtes Fahrzeug?",
      note_text:
        "Ich berate Sie gerne zu allen Themen rund um Fahrzeugimport, Verzollung und individuelle Fahrzeugsuche.",
    },

    contact: {
      title: "Kontaktieren Sie mich gerne",
      brand: "AUTO M.A.H.",
      map_title: "Standort Daimlerstraße 10, Steinen. Öffnet die Route in Google Maps.",
      hours_title: "Anfragen jederzeit",
      hours_main: "Formular, WhatsApp oder E-Mail, rund um die Uhr",
      area_title: "Wo ich Fahrzeuge ankaufe",
      area_lead: "Ich kaufe im gesamten Dreiländereck an. Weiter entfernt ist kein Problem, sprechen Sie mich an.",
      area_regions: [
        { land: "Deutschland", gebiete: ["Landkreis Lörrach", "Landkreis Waldshut", "Region Freiburg"] },
        { land: "Schweiz", gebiete: ["Region Basel", "Kanton Aargau", "Kanton Solothurn", "Kanton Bern", "Kanton Zürich"] },
        { land: "Frankreich", gebiete: ["Elsass"] },
      ],
      area_ch_link: "Sie verkaufen aus der Schweiz? So läuft der Ankauf über die Grenze",
    },

    vehicle: {
      max_5_images:
        "Bitte max. 5 Bilder hochladen. Es werden nur die ersten 5 berücksichtigt.",
    },

    // ======================
    // CarForm (NEU)
    // ======================
    carform: {
      title: "Ankauf-Anfrage oder Wunschauto-Service",
      service_title: "Welchen Service wünschen Sie?",
      service_purchase: "Fahrzeug verkaufen (Ankauf)",
      service_wish: "Wunschauto finden (Vermittlung)",

      vehicle_title: "Fahrzeug-Daten",
      brand_label: "Marke *",
      brand_placeholder: "Bitte wählen",
      brand_other_label: "Eigene Marke *",
      brand_other_ph: "z.B. Alfa Romeo",
      model_label: "Modell *",
      model_placeholder: "Bitte Modell wählen",
      model_first_choose: "Bitte zuerst Marke wählen",
      model_other_label: "Modell *",
      model_other_ph: "z.B. Giulia",
      year_label: "Baujahr *",
      year_ph: "z.B. {example}",
      mileage_label: "Kilometerstand *",
      mileage_ph: "z.B. 75000",

      price_title: "Preisvorstellung",
      price_label: "Ihre Preisvorstellung *",
      currency_label: "Währung",
      price_ph: "Welchen Preis haben Sie sich vorgestellt?",

      budget_title: "Budgetvorstellung",
      budget_label: "Ihre Budgetvorstellung",
      budget_ph: "Wie hoch ist Ihr Maximalbudget?",

      features_title: "Ihre Wunschausstattung",
      optional_marke: "optional",
      equipment_label: "Besondere Ausstattungswünsche",
      equipment_ph:
        "z.B. Lederausstattung, Panoramadach, Sonderausstattung...",
      color_label: "Bevorzugte Farbe",
      color_ph: "Farbe des Fahrzeugs",
      fuel_label: "Kraftstoffart",
      fuel_placeholder: "Bitte wählen",
      fuel_petrol: "Benzin",
      fuel_diesel: "Diesel",
      fuel_hybrid: "Hybrid",
      fuel_electric: "Elektro",
      fuel_any: "Egal",
      getriebe_label: "Getriebe",
      getriebe_auto: "Automatik",
      getriebe_hand: "Schaltgetriebe",
      bauart_label: "Karosserieform",
      bauart_limousine: "Limousine",
      bauart_kombi: "Kombi",
      bauart_suv: "SUV / Geländewagen",
      bauart_coupe: "Coupé",
      bauart_cabrio: "Cabrio",
      bauart_klein: "Kleinwagen",
      bauart_van: "Van / Bus",
      bauart_pickup: "Pick-up",
      tueren_label: "Türen",
      tueren_23: "2 oder 3",
      tueren_45: "4 oder 5",
      sitze_label: "Sitzplätze",
      sitze_2: "2",
      sitze_45: "4 bis 5",
      sitze_67: "6 bis 7",
      sitze_mehr: "mehr als 7",
      egal: "Egal",
      field_getriebe: "Getriebe",
      field_bauart: "Karosserieform",
      field_tueren: "Türen",
      field_sitze: "Sitzplätze",

      photos_title: "Fahrzeug-Fotos",
      photos_label: "Bilder hochladen *",
      files_none: "Keine Dateien ausgewählt",
      files_count: "{count} Datei(en): {names}",
      photos_hint:
        "Bitte laden Sie Fotos von allen Seiten, Innenraum und eventuellen Schäden hoch (max. 10 Bilder).",
      req_title: "Erforderliche Fotos:",
      req_front: "Frontansicht",
      req_rear: "Heckansicht",
      req_sides: "Seitenansicht (beide Seiten)",
      req_interior: "Innenraum",
      req_odo: "Tachometer (Kilometerstand)",
      req_damage: "Eventuelle Schäden oder Defekte",

      contacts_title: "Ihre Kontaktdaten",
      name_label: "Name *",
      name_ph: "Ihr Name",
      email_label: "E-Mail",
      email_ph: "Ihre E-Mail",
      phone_label: "Telefon",
      kontaktweg_hinweis: "Telefon oder E-Mail genügt - eines von beiden brauche ich, um mich zu melden.",
      phone_ph: "Ihre Telefonnummer",
      location_label: "Ort/PLZ *",
      land_label: "Land *",
      land_placeholder: "Bitte wählen",
      land_de: "Deutschland",
      land_ch: "Schweiz",
      land_fr: "Frankreich",
      land_other: "Anderes Land",
      location_ph: "Ihr Standort",
      message_label: "Nachricht (optional)",
      message_ph: "Zusätzliche Informationen oder Terminwünsche...",
      privacy_prefix: "Hinweis zum Datenschutz: Ihre Angaben verwende ich nur, um Ihre Anfrage zu bearbeiten. Einzelheiten stehen in der",
      privacy_link: "Datenschutzerklärung",
      privacy_suffix: ".",

      btn_sending: "Senden…",
      btn_submit_purchase: "Kostenlose Bewertung anfordern",
      btn_submit_wish: "Kostenlose Fahrzeugsuche anfragen",

      alert_max10:
        "Bitte maximal 10 Bilder hochladen. Es werden nur die ersten 10 übernommen.",
      err_brand: "Bitte eine Automarke wählen.",
      err_brand_other: "Bitte die Marke eintragen.",
      err_model_other: "Bitte das Modell eintragen.",
      err_model: "Bitte ein Modell wählen.",
      err_year_range: "Baujahr muss zwischen {min} und {max} liegen.",
      err_mileage: "Kilometerstand ist ungültig.",
      err_price: "Bitte eine gültige Preisvorstellung angeben.",
      err_images_required: "Bitte mindestens ein Fahrzeugfoto hochladen.",
      err_contacts: "Bitte Name, Ort/PLZ und Land ausfüllen.",
      err_kontaktweg: "Bitte Telefon ODER E-Mail angeben, damit ich mich melden kann.",
      err_privacy: "Bitte der Datenschutzerklärung zustimmen.",
      err_webhook: "Senden hat nicht geklappt. Bitte später noch einmal oder per WhatsApp / Telefon.",
      err_generic: "Senden hat nicht geklappt. Bitte später noch einmal oder per WhatsApp / Telefon.",
      success_alert: "Danke, Ihre Anfrage ist angekommen. Ich melde mich.",
      warn_only_first10:
        "Es werden nur die ersten 10 Bilder mitgeschickt.",
      brand_other_fallback: "Andere",

      embed: {
        title_purchase: "Ankauf-Anfrage",
        title_wish: "Wunschauto-Anfrage",
        service_name: "Service",
      },
      service_purchase_full: "Ankauf (Fahrzeug verkaufen)",
      service_wish_full: "Vermittlung (Wunschauto)",

      field_brand: "Marke",
      field_model: "Modell",
      field_year: "Baujahr",
      field_mileage: "Kilometerstand",
      field_price: "Preisvorstellung",
      field_budget: "Budget",
      field_color: "Farbe",
      field_fuel: "Kraftstoff",
      field_equipment: "Ausstattung",
      field_name: "Name",
      field_phone: "Telefon",
      field_email: "E-Mail",
      field_location: "Ort/PLZ",
      field_land: "Land",
      field_message: "Nachricht",

      discord_content_purchase: "Neue Ankauf-Anfrage",
      discord_content_wish: "Neue Wunschauto-Anfrage",
    },

    // ===== GeneralForm (NEU) =====
    generalform: {
      heading_intro: "Bei welchem Anliegen kann ich behilflich sein?",
      topic_label: "Anliegen *",
      topic_placeholder: "Bitte wählen",
      topic_zoll: "Zoll, Papiere & Zulassung",
      topic_zoll_hilfe: "Einfuhr, Verzollung, Zulassung, Ablauf",
      topic_sonstiges: "Etwas anderes",
      topic_sonstiges_hilfe: "Alles, was hier nicht passt",
      topic_ankauf: "Auto verkaufen",
      topic_ankauf_hilfe: "Öffnet das Ankauf-Formular",
      topic_wunschauto: "Wunschauto finden",
      topic_wunschauto_hilfe: "Öffnet die Fahrzeugsuche",

      contacts_title: "Ihre Kontaktdaten",
      name_label: "Name *",
      name_ph: "Ihr Name",
      email_label: "E-Mail",
      email_ph: "Ihre E-Mail",
      phone_label: "Telefon",
      kontaktweg_hinweis: "Telefon oder E-Mail genügt - eines von beiden brauche ich, um mich zu melden.",
      phone_ph: "Ihre Telefonnummer",
      location_label: "Ort/PLZ *",
      location_ph: "Ihr Standort",
      message_label: "Nachricht (optional)",
      message_ph: "Zusätzliche Informationen oder Terminwünsche...",

      privacy_prefix: "Hinweis zum Datenschutz: Ihre Angaben verwende ich nur, um Ihre Anfrage zu bearbeiten. Einzelheiten stehen in der",
      privacy_link: "Datenschutzerklärung",
      privacy_suffix: ".",

      btn_sending: "Senden…",
      btn_submit: "Anfrage senden",

      err_topic: "Bitte ein Anliegen auswählen.",
      err_name: "Bitte Ihren Namen eintragen.",
      err_email: "Bitte Ihre E-Mail eintragen.",
      err_phone: "Bitte Ihre Telefonnummer eintragen.",
      err_location: "Bitte Ihren Ort/PLZ eintragen.",
      err_land: "Bitte das Land auswählen.",
      err_privacy: "Bitte der Datenschutzerklärung zustimmen.",
      err_webhook: "Senden hat nicht geklappt. Bitte später noch einmal oder per WhatsApp / Telefon.",
      err_generic: "Senden hat nicht geklappt. Bitte später noch einmal oder per WhatsApp / Telefon.",
      success_alert: "Danke, Ihre Anfrage ist angekommen. Ich melde mich.",

      field_topic: "Anliegen",
      field_name: "Name",
      field_phone: "Telefon",
      field_email: "E-Mail",
      field_location: "Ort/PLZ",
      field_message: "Nachricht",

      embed_title: "Neue Kontaktanfrage ({topic})",
      discord_content: "Neue Kontaktanfrage ({topic})",
    },

    // ========= Footer ==========
    footer: {
        quick_contact: "Schnellkontakt",
        brand: "AUTO M.A.H.",
        owner_label: "Inhaber:",
        owner_name: "Mohamed Ali Hussein",
        address: "Daimlerstr. 10, 79585 Steinen, DE",
        legal: "Rechtliches",
        imprint: "Impressum",
        privacy: "Datenschutzerklärung",
        tos: "Allgemeine Geschäftsbedingungen",
        info: "Infos",
        broker_service: "Vermittlungsservice",
        broker_text: "Beim Wunschauto kaufe ich das Fahrzeug je nach Fall selbst an oder vermittle gegen Provision.",
        vat_line: "Umsatzsteuer-Identifikationsnummer nach § 27a UStG: DE402063042",
        bottom_line: "© {year} AUTO M.A.H. - Autoimport & Verzollung • B2B • Handel • Export • Vermittlung",
    },

    // ========== Privacy =================
    privacy: {
        title: "Datenschutzerklärung",
        html: `
            <h2>1. Datenschutz auf einen Blick</h2>
            <h3>Allgemeine Hinweise</h3>
            <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie meiner unter diesem Text aufgeführten Datenschutzerklärung.</p>

            <h3>Datenerfassung auf dieser Website</h3>
            <h4>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
            <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.</p>
            <h4>Wie erfasse ich Ihre Daten?</h4>
            <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie sie mir mitteilen. Hierbei kann es sich z.&nbsp;B. um Daten handeln, die Sie in ein Kontaktformular eingeben.</p>
            <p>Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch meine IT-Systeme erfasst (z.&nbsp;B. Browser, Betriebssystem, Zeitpunkt des Aufrufs). Die Erfassung dieser technischen Daten erfolgt automatisch, sobald Sie diese Website betreten.</p>
            <h4>Wofür nutze ich Ihre Daten?</h4>
            <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Eine Analyse des Nutzerverhaltens findet nicht statt.</p>
            <h4>Welche Rechte haben Sie bezüglich Ihrer Daten?</h4>
            <p>Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie das Recht auf Beschwerde bei einer Aufsichtsbehörde. Hierzu sowie zu weiteren Fragen können Sie sich jederzeit an mich wenden.</p>

            <h3>Analyse-Tools und Tools von Drittanbietern</h3>
            <p>Ich setze selbst <strong>kein Tracking</strong> und <strong>keine Analyse-Tools</strong> ein. Es gibt keine Profilbildung und keine Reichweitenmessung.</p>
            <p>Der Hosting-Anbieter Cloudflare kann aus technischen Gründen eigene Cookies setzen, zum Beispiel zum Schutz vor automatisierten Zugriffen. Das sind keine Werbe-Cookies von mir.</p>
            <p>Die Nutzung dieser Website ist ohne Angabe personenbezogener Daten möglich, sofern Sie mir nicht freiwillig schreiben.</p>

            <h2>2. Hosting</h2>
            <p>Ich hoste die Inhalte meiner Website bei folgendem Anbieter:</p>
            <h3>Cloudflare</h3>
            <p>Anbieter ist die Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, USA („Cloudflare“). Die Website wird über Cloudflare Pages bereitgestellt. Beim Besuch können Server-Logfiles verarbeitet werden (z. B. IP-Adresse, Datum/Uhrzeit, Referrer-URL, User-Agent). Details: <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">Privacy Policy von Cloudflare</a>.</p>
            <p>Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer zuverlässigen, performanten und sicheren Bereitstellung). Cloudflare verarbeitet Daten auch in den USA. Diese Übermittlung stütze ich auf den Angemessenheitsbeschluss der EU-Kommission nach Art. 45 DSGVO (EU-U.S. Data Privacy Framework); Cloudflare, Inc. ist unter diesem Rahmen zertifiziert. Cloudflare stellt einen Auftragsverarbeitungsvertrag nach Art. 28 DSGVO bereit.</p>

            <h2>3. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3>Datenschutz</h3>
            <p>Ich behandle Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Vorschriften sowie dieser Datenschutzerklärung. Bitte beachten Sie, dass die Datenübertragung im Internet Sicherheitslücken aufweisen kann.</p>

            <h3>Hinweis zur verantwortlichen Stelle</h3>
            <p>Verantwortlich: Mohamed Ali Hussein<br>Daimlerstr. 10, 79585 Steinen, Deutschland</p>
            <p>Telefon: +49 (0) 176 960 849 98<br>E-Mail: info@auto-mah.com</p>

            <h3>Speicherdauer</h3>
            <p>Anfragen über das Formular werden bei Cloudflare gespeichert und dort <strong>spätestens nach 12 Monaten automatisch gelöscht</strong>. Ist eine Anfrage vorher erledigt, lösche ich sie sofort. Gesetzliche Aufbewahrungspflichten (etwa nach einem späteren Vertrag) bleiben unberührt. Im Übrigen bleiben personenbezogene Daten bei mir, bis der Verarbeitungszweck entfällt oder Sie die Löschung verlangen.</p>

            <h3>Rechtsgrundlagen</h3>
            <p>Je nach Fall: Art. 6 Abs. 1 lit. a (Einwilligung), lit. b (Vertrag/Vorvertrag), lit. c (rechtliche Verpflichtung) oder lit. f (berechtigtes Interesse) DSGVO. Einwilligungen können jederzeit mit Wirkung für die Zukunft widerrufen werden.</p>

            <h3>Empfänger von personenbezogenen Daten</h3>
            <p>Eine Weitergabe an Dritte erfolgt nicht, außer wenn gesetzlich vorgeschrieben, zur Vertragserfüllung erforderlich, berechtigte Interessen überwiegen oder eine andere Rechtsgrundlage dies erlaubt.</p>

            <h3>Ihre Rechte</h3>
            <p>Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch (Art. 21 DSGVO), Datenübertragbarkeit, Beschwerderecht bei einer Aufsichtsbehörde. Zuständig ist der Landesbeauftragte für Datenschutz und Informationsfreiheit Baden-Württemberg: <a href="https://www.baden-wuerttemberg.datenschutz.de/" target="_blank" rel="noopener noreferrer">baden-wuerttemberg.datenschutz.de</a>.</p>

            <h3>SSL-/TLS-Verschlüsselung</h3>
            <p>Diese Seite nutzt SSL-/TLS-Verschlüsselung. Erkennbar an „https://“ und dem Schloss-Symbol im Browser.</p>

            <h2>4. Datenerfassung auf dieser Website</h2>
            <h3>Server-Log-Dateien</h3>
            <p>Technische Daten (z. B. Browsertyp/-version, Betriebssystem, Referrer-URL, Hostname, Uhrzeit, IP-Adresse) können durch den Provider verarbeitet werden. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (technische Bereitstellung).</p>

            <h3>Kontaktformular</h3>
            <p>Wenn Sie mich über das Kontaktformular kontaktieren, verarbeite ich die von Ihnen freiwillig eingegebenen Daten (z. B. Name, Telefon, E-Mail, Fahrzeugdaten) ausschließlich zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme.</p>
            <p><strong>Übermittlung Ihrer Anfrage:</strong> Ihre Anfrage wird von einem Dienst entgegengenommen, den ich bei <strong>Cloudflare</strong> (Cloudflare, Inc., USA) betreibe, und dort gespeichert; dabei wird Ihre IP-Adresse technisch verarbeitet. Mit Cloudflare besteht ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO. In meinem internen Chat beim Anbieter <strong>Discord</strong> (Discord Inc., USA) erhalte ich <strong>nur eine Benachrichtigung</strong>, dass eine Anfrage eingegangen ist, mit laufender Nummer und Uhrzeit. Ihr Name, Ihre Kontaktdaten, Ihre Fahrzeugangaben und Ihre Fotos werden an Discord <strong>nicht</strong> übermittelt. Die Anfrage selbst kann nur ich einsehen; der Zugang ist durch ein Zugangsmerkmal und eine PIN geschützt. Cloudflare verarbeitet Daten auch in den USA. Rechtsgrundlage für diese Übermittlung ist der Angemessenheitsbeschluss der EU-Kommission nach Art. 45 DSGVO (EU-U.S. Data Privacy Framework); Cloudflare, Inc. ist unter diesem Rahmen zertifiziert. Eine darüber hinausgehende Weitergabe an Dritte, insbesondere zu Werbezwecken, erfolgt nicht.</p>
            <p>Rechtsgrundlagen: Art. 6 Abs. 1 lit. b DSGVO (Vertrag/Vorvertrag) oder lit. f DSGVO (berechtigtes Interesse an effektiver Kommunikation) bzw. lit. a DSGVO (Einwilligung, sofern abgefragt). Die Daten werden auf Wunsch oder nach Abschluss der Kommunikation gelöscht, gesetzliche Aufbewahrungsfristen bleiben unberührt.</p>

            <h3>WhatsApp</h3>
            <p>Wenn Sie mir über den WhatsApp-Knopf schreiben, wird das Gespräch bei WhatsApp Ireland Limited / Meta Platforms verarbeitet. Es gelten die Datenschutzhinweise von WhatsApp. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b oder lit. f DSGVO (Kontaktaufnahme, die Sie selbst beginnen).</p>

            <h3>Karte (Google Maps)</h3>
            <p>Auf der Kontaktseite zeige ich meinen Standort als festes Kartenbild, das ich selbst auf dieser Website speichere. Dabei wird kein Kartendienst geladen. Wenn Sie die Karte anklicken, verlassen Sie meine Website und öffnen Google Maps (Google Ireland Limited / Google LLC, USA) mit der Zieladresse für die Hinfahrt. Dann gelten die Hinweise von Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Datenschutzerklärung von Google</a>.</p>

            <h3>Spracheinstellung</h3>
            <p>Ihre Sprachwahl (DE, EN oder FR) speichere ich nur lokal in Ihrem Browser (localStorage, Schlüssel „lang“), damit die Seite in der gewählten Sprache bleibt. Nichts wird ausgewertet. Den Eintrag können Sie in den Browsereinstellungen löschen.</p>

            <h3>Fahrzeuganfragen</h3>
            <p>Wenn Sie Fotos oder Fahrzeugdaten schicken, verwende ich sie nur, um Ihre Anfrage zu bearbeiten. Sie werden nicht veröffentlicht und nicht zu Werbung genutzt.</p>

            <h3>Zulassung</h3>
            <p>Ich melde Fahrzeuge nur in Deutschland an. Wenn ich ein Fahrzeug für Sie zulasse, brauche ich dafür Ihre Angaben aus dem Ausweis, die eVB-Nummer Ihrer Versicherung, die Fahrzeugpapiere und für die Kfz-Steuer Ihre Bankverbindung mit SEPA-Mandat. Dazu kommt eine Vollmacht von Ihnen. Diese Daten nutze ich ausschliesslich für die Zulassung und gebe sie nur an die deutsche Zulassungsstelle und die dort beteiligten Stellen weiter. Nach Abschluss der Zulassung lösche ich sie, soweit keine gesetzliche Aufbewahrungspflicht besteht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertrag).</p>

            <h3>Anfrage per E-Mail oder Telefon</h3>
            <p>Bei Kontaktaufnahme per E-Mail oder Telefon verarbeite ich Ihre Angaben zum Zweck der Bearbeitung. Meine Adresse info@auto-mah.com ist eine Weiterleitung: Ihre Nachricht läuft über die Mailserver der IONOS SE, Montabaur, und wird in einem Postfach bei der Microsoft Corporation (Outlook.com) zugestellt. Darüber hinaus gebe ich nichts ohne Ihre Einwilligung weiter. Rechtsgrundlagen wie vorstehend; Löschung nach Zweckerfüllung oder auf Wunsch.</p>
        `,
    },

    // ======= AGB =========
    tos: {
    title: "Allgemeine Geschäftsbedingungen (AGB)",
    html: `
        <h3>1. Wozu diese Seite da ist</h3>
        <p>
        Diese Website ist die digitale Visitenkarte von <strong>AUTO M.A.H.</strong>
        (Inhaber: Mohamed Ali Hussein). Sie dient der Vorstellung und der Kontaktaufnahme.
        Es gibt keinen Online-Shop. Über die Seite wird nichts verkauft und nichts bezahlt.
        Das Geschäft läuft außerhalb der Website: persönlich, am Telefon oder vor Ort.
        </p>

        <h3>2. Was ich anbiete</h3>
        <ul>
        <li><strong>Fahrzeugankauf:</strong> Sie können mir Ihr Auto zum Kauf anbieten.</li>
        <li><strong>Wunschauto:</strong> Ich suche auf Wunsch ein Auto. Je nach Fall kaufe ich es selbst an und verkaufe es Ihnen weiter, oder ich vermittle nur und erhalte eine Provision, wenn es klappt. Was von beidem gilt, halten wir vorher fest.</li>
        <li><strong>Fahrzeuge auf der Seite:</strong> Wenn ich Autos zeige, sind das Informationen ohne Preis. Das ist kein verbindliches Angebot und kein Online-Verkauf.</li>
        </ul>

        <h3>3. Anfrage und Kauf</h3>
        <p>
        Ein Formular, ein Anruf oder eine Nachricht ist noch kein Vertrag.
        Preis und Kauf klären wir nur persönlich, am Telefon oder vor Ort.
        </p>
        <p>
        Angaben zu Fahrzeugen auf der Seite (Fotos, Daten) sind unverbindlich und können sich ändern.
        Ein Kaufvertrag entsteht erst außerhalb der Website.
        Es findet kein Fernabsatzkauf über die Seite statt.
        </p>

        <h3>4. Haftung</h3>
        <p>
        Ich bemühe mich um richtige Angaben. Für Vollständigkeit und Aktualität der Website übernehme ich keine Garantie.
        </p>
        <p>
        Für Schäden hafte ich nach den gesetzlichen Vorschriften. Eine Beschränkung meiner Haftung ist damit
        nicht verbunden.
        </p>

        <h3>5. Verbraucherschlichtung</h3>
        <p>
        Ich bin nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <h3>6. Datenschutz</h3>
        <p>
        Daten aus Formular oder E-Mail nutze ich nur für Ihre Anfrage.
        Ihre Anfrage wird bei Cloudflare gespeichert; über Discord erhalte ich nur eine Benachrichtigung ohne Ihre Daten.
        Einzelheiten stehen in der <a href="/privacy">Datenschutzerklärung</a>.
        </p>

        <h3>7. Schluss</h3>
        <p>
        Es gilt das Recht der Bundesrepublik Deutschland. Ist der Kunde Kaufmann, juristische Person des
        öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist Gerichtsstand Lörrach.
        Gegenüber Verbrauchern gelten die gesetzlichen Gerichtsstände.
        </p>
    `,
    },

    // ========= Impressum ==========
    imprint: {
        title: "Impressum",
        html: `
            <p><strong>AUTO M.A.H.</strong><br>
            Inhaber: Mohamed Ali Hussein</p>

            <p>
            Daimlerstr. 10<br>
            79585 Steinen, Deutschland
            </p>

            <p>
            Tel.: <a href="tel:+4917696084998">+49 176 96084998</a><br>
            E-Mail: <a href="mailto:info@auto-mah.com">info@auto-mah.com</a>
            </p>

            <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br>
            <strong>DE402063042</strong>
            </p>

            <p>Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG).</p>

            <p>
            Diese Website dient der Kontaktaufnahme. Verträge über Fahrzeuge werden nicht über die Website geschlossen.
            </p>

            <p><strong>Verantwortlich i. S. d. § 18 Abs. 2 MStV</strong><br>
            Mohamed Ali Hussein, Daimlerstr. 10, 79585 Steinen
            </p>

            <h3>Verbraucherstreitbeilegung</h3>
            <p>
            Ich bin nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h3>Hosting</h3>
            <p>
            Die Website wird bei Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, USA
            (Cloudflare Pages) bereitgestellt. Einzelheiten zur Datenverarbeitung stehen in der
            <a href="/privacy">Datenschutzerklärung</a>.
            </p>
        `,
    },



  },

  en: {

    // ======================
    // Regional page Switzerland (/auto-verkaufen-schweiz)
    // ======================
    chpage: {
      meta_title: "Selling your car in Switzerland | Purchase and customs | AUTO M.A.H.",
      meta_desc: "Want to sell your car in Switzerland? I buy it and handle export and customs myself. Free valuation, Basel region, Aargau, Solothurn, Bern and Zurich.",
      h1: "Selling your car in Switzerland",
      lead: "Your car is in Switzerland and you want to sell it. I buy it and collect it. The way across the border is my job.",
      cta: "Offer your vehicle",
      cta_hint: "Free and without obligation. Sending an enquiry commits you to nothing.",

      why_title: "Why sell to me",
      why1_title: "I handle customs myself",
      why1_text: "I do not hand customs clearance to a forwarding agent. Because I do it for my own vehicles all the time, I know the rules and the paperwork from practice.",
      why2_title: "The way is short",
      why2_text: "I am based in Steinen in the border triangle, right at the border. I can be with you quickly.",
      why3_title: "In the car trade since 2007",
      why3_text: "I have been self-employed in the car trade since 2007 and I am not a middleman who still has to find a buyer for your car.",
      why4_title: "Look first, then decide",
      why4_text: "Everything stays free and without obligation until we agree after the inspection.",

      zoll_title: "What customs has to do with it",
      zoll_p1: "For customs purposes Switzerland is a third country. When a vehicle moves from there to Germany, as a rule 10 percent duty and 19 percent import VAT apply.",
      zoll_p2: "That is the point where many buyers from Germany give up. For me it is routine: I declare and import the vehicle myself. For you as the seller nothing about the process changes.",
      zoll_hinweis: "General information to the best of my knowledge, not legal or tax advice. Individual cases may differ, just ask me.",

      ablauf_title: "How it works",
      area_title: "Where I buy in Switzerland",
      area_lead: "Further away is not a problem, just get in touch.",
      area_list: ["Basel region", "Canton of Aargau", "Canton of Solothurn", "Canton of Bern", "Canton of Zurich"],

      was_title: "What you need",
      was_lead: "In short: very little. I take care of the largest part.",
      sie_title: "For a Swiss vehicle you need",
      was1_title: "Vehicle registration document",
      was1_text: "The Fahrzeugausweis is the only thing you need to have ready yourself.",
      was2_title: "Sales contract",
      was2_text: "We draw it up together as soon as we agree on the price.",
      andere_text: "A different case? A German vehicle standing in Switzerland, a company car or a dealer vehicle: get in touch, I know that route as well.",
      rest_title: "What I take care of",
      rest1_title: "Deregistration",
      rest1_text: "I handle deregistering the vehicle.",
      rest2_title: "Transport",
      rest2_text: "I come with a transporter and collect the vehicle from you. You do not have to drive anywhere.",
      rest3_title: "Import into Germany",
      rest3_text: "Export, customs clearance and import are my job. You have nothing to do with it.",
      schluss_title: "Do you have a vehicle?",
      schluss_text: "Send me the key details and a few photos. I will come back to you with an honest assessment.",
    },
    nav_home: "Home",
    nav_services: "Services",
    nav_purchase: "Vehicle Purchase",
    nav_cars: "Vehicles",
    nav_cta: "Sell your car",
    nav_about: "About me",
    nav_contact: "Contact",

    global: {
      demo_submit_info:
        "Thanks! Your request has been recorded (demo). Please connect a backend.",
    },

    nf: {
      titel: "This page does not exist",
      text: "The link leads nowhere. Maybe a typo, maybe an old address.",
      start: "Go to homepage",
      hilfe: "Looking for something specific? Give me a call:",
    },
    hero: {
      title: "We buy and import cars in Germany, Switzerland and France",
      subtitle:
        "Right at the three-country border • Purchase DE · CH · FR • Customs Clearance • Registration • EU Export",
      cta: "Request Purchase Now",
      cta_whatsapp: "WhatsApp",
      whatsapp_text: "Hello, I would like to sell my car.",
      cta_anruf: "Call now",
      schliessen: "Close",
      badge_fair: "Fair prices",
      badge_fast: "Fast processing",
      badge_pro: "Own customs clearance",
      badge_wish: "Dream car service",
    },

    services: {
      title: "My Services",
      card1: {
        title: "Vehicle Purchase Germany, Switzerland & France",
        text: "I purchase high-quality vehicles directly on the German, Swiss and French markets - fair prices, fast processing",
      },
      card2: {
        title: "Import & Customs Clearance",
        text: "I import and clear my cars from Switzerland myself, not through a forwarding agent. You buy a car that is already fully imported.",
      },
      card3: {
        title: "German Registration & TÜV Inspection",
        text: "Service and TÜV main inspection - vehicle-ready for sale",
      },
      card4: {
        title: "Trade & Distribution",
        text: "Sale of imported vehicles on the German market or export to EU countries",
      },
      card5: {
        title: "Dream Car Service",
        text: "Looking for a specific car? I find it to your specifications - make, equipment, budget. Nationally and internationally.",
      },
      card6: {
        title: "Custom Vehicle Search",
        text: "Targeted search for your dream car with specific equipment and budget requirements",
      },
    },

    faq: {
      title: "Frequently asked questions",
      subtitle: "What buyers and sellers ask me most often.",
      hinweis: "General information to the best of my knowledge, not legal or tax advice. Individual cases may differ, just ask me.",
      q1: "Are your cars from Switzerland properly imported?",
      a1: "Yes. For customs purposes Switzerland is a third country, so as a rule 10% duty and 19% import VAT apply. I handle the customs clearance myself rather than through a forwarding agent. I only pass a vehicle on once the import is completed and the customs papers are on file.",
      q2: "What does that mean for me as a buyer?",
      a2: "You get a vehicle whose import is completed and whose papers are complete. What is needed for registration I go through with you beforehand, along with the status of the main and emissions inspection. We put that in writing for your vehicle.",
      q3: "Do you also sell to dealers or abroad within the EU?",
      a3: "Yes. I sell to private customers in Germany, to dealers, and I export to other EU countries. Just ask about your case, separate terms apply for dealers and export.",
      q4: "I want to sell my car. How does it work?",
      a4: "You send me the key details and a few photos, via the form, WhatsApp or phone. I come back with an honest assessment. Only once we agree after the viewing does it become a deal. Until then everything is non-binding and free of charge.",
      q5: "I am selling from Switzerland. What do I have to do?",
      a5: "You only need the vehicle registration document, we draw up the sales contract together. Deregistration, transport and the import into Germany are my job. You do not have to drive anywhere.",
      a5_link: "More on this: selling your car in Switzerland",
    },

    ablauf: {
      title: "Want to sell your car?",
      subtitle: "This is how the purchase works. Four steps, no risk: everything is non-binding until we agree.",
      s1_title: "Send your inquiry",
      s1_text: "Via the form, WhatsApp or phone. Photos help me assess the car. Non-binding and free of charge.",
      s2_title: "Get a valuation",
      s2_text: "I review your details and come back to you with an honest assessment and a price proposal.",
      s3_title: "Viewing & agreement",
      s3_text: "We look at the vehicle together. Only once we agree does the inquiry become a deal.",
      s4_title: "Sale & handover",
      s4_text: "We agree, you get your money and I take over the vehicle including the documents. Everything after that is my job.",
    },

    purchase: {
      title: "Vehicle Purchase & Mediation",
      subtitle:
        "I buy your vehicle directly or help you find your dream car",
      offer_two_services: "I offer two services:",
      feature_buy: {
        title: "Vehicle purchase",
        text: "I buy your car on fair terms",
      },
      feature_wish: {
        title: "Dream car service",
        text: "I find your dream car according to your specifications",
      },
      feature_note:
        "Whether selling or buying – I make you a fair offer and find your dream vehicle!",

      accept_all_title: "I buy cars of all brands and models",
      accept_high_mileage: "Even with high mileage",
      accept_defects: "Vehicles with defects or damage",
      accept_accident: "Accident vehicles",
      accept_total_loss: "Economic total loss",
      accept_young_old: "Young and old vehicles",
      accept_luxury_daily: "Luxury & daily cars",
      accept_with_without_history: "With or without service history",
      fair_offer_any_condition:
        "No matter the condition – I will make you a fair offer!",
    },

    cars: {
      title: "Cars for sale",
      lead: "If you're looking for a car, ask me. I'll give you the price in person. Purchase is with me, not through the site.",
      price: "Price on request",
      btn: "Ask about it",
      open: "See cars",
      soon: "Nothing listed yet",
      soon_text: "I don't have cars on the site right now. If you're looking for something, just write to me. I'll see what I can find.",
      anfrage_text: "Enquiry about: {auto}",
    },

    about: {
      title: "About AUTO M.A.H.",
      owner_alt: "Owner AUTO M.A.H.",
      owner_name: "Mohamed Ali Hussein",
      owner_role: "Owner & Managing Director",
      qr_text: "SEND PHOTO · GET AN OFFER",
      headline:
        "Your specialist for vehicle purchase and import in the German-Swiss-French border region",
      p1: "I've been self-employed in the car trade since 2007. Today I'm based in Steinen, right at the three-country border. From here I get to Germany, Switzerland and France quickly. Cars from Switzerland I clear through German customs, then sell them in Germany or into the EU.",
      p2: "I handle the customs clearance myself instead of passing it to a forwarding agent. Because I do it continuously for my own vehicles, I know the German regulations and the required paperwork from practice, not from a textbook. That keeps the route from Switzerland to Germany short and predictable.",
      new_wish_service_title: "Dream Car Service",
      new_wish_service_text:
        "Looking for a specific car with particular equipment? I will look for it, here and abroad.",
      note_strong:
        "Do you have questions about car import or are you looking for a specific vehicle?",
      note_text:
        "I will be happy to advise you on all topics related to vehicle import, customs clearance and individual vehicle search.",
    },

    contact: {
      title: "Feel free to contact me",
      brand: "AUTO M.A.H.",
      map_title: "Location Daimlerstraße 10, Steinen. Opens directions in Google Maps.",
      hours_title: "Enquiries any time",
      hours_main: "Form, WhatsApp or email, around the clock",
      area_title: "Where I buy vehicles",
      area_lead: "I buy across the whole three-country corner. Further away is no problem, just ask me.",
      area_regions: [
        { land: "Germany", gebiete: ["District of Lörrach", "District of Waldshut", "Freiburg region"] },
        { land: "Switzerland", gebiete: ["Basel region", "Canton of Aargau", "Canton of Solothurn", "Canton of Bern", "Canton of Zurich"] },
        { land: "France", gebiete: ["Alsace"] },
      ],
      area_ch_link: "Selling from Switzerland? How the purchase across the border works",
    },

    vehicle: {
      max_5_images:
        "Please upload a maximum of 5 images. Only the first 5 will be considered.",
    },

    // ======================
    // CarForm (NEW)
    // ======================
    carform: {
      title: "Sell Your Car or Request a Dream Car",
      service_title: "Which service do you need?",
      service_purchase: "Sell a car (Purchase)",
      service_wish: "Find a car (Mediation)",

      vehicle_title: "Vehicle Details",
      brand_label: "Brand *",
      brand_placeholder: "Please select",
      brand_other_label: "Custom brand *",
      brand_other_ph: "e.g., Alfa Romeo",
      model_label: "Model *",
      model_placeholder: "Please select a model",
      model_first_choose: "Please select a brand first",
      model_other_label: "Model *",
      model_other_ph: "e.g., Giulia",
      year_label: "Year *",
      year_ph: "e.g., {example}",
      mileage_label: "Mileage *",
      mileage_ph: "e.g., 75000",

      price_title: "Expected Price",
      price_label: "Your expected price *",
      currency_label: "Currency",
      price_ph: "What price do you have in mind?",

      budget_title: "Budget",
      budget_label: "Your budget",
      budget_ph: "What is your maximum budget?",

      features_title: "Desired Features",
      optional_marke: "optional",
      equipment_label: "Special equipment wishes",
      equipment_ph:
        "e.g., leather seats, panoramic roof, special options...",
      color_label: "Preferred color",
      color_ph: "Vehicle color",
      fuel_label: "Fuel type",
      fuel_placeholder: "Please select",
      fuel_petrol: "Petrol",
      fuel_diesel: "Diesel",
      fuel_hybrid: "Hybrid",
      fuel_electric: "Electric",
      fuel_any: "Any",
      getriebe_label: "Transmission",
      getriebe_auto: "Automatic",
      getriebe_hand: "Manual",
      bauart_label: "Body type",
      bauart_limousine: "Saloon",
      bauart_kombi: "Estate",
      bauart_suv: "SUV / off-road",
      bauart_coupe: "Coupé",
      bauart_cabrio: "Convertible",
      bauart_klein: "Small car",
      bauart_van: "Van / minibus",
      bauart_pickup: "Pick-up",
      tueren_label: "Doors",
      tueren_23: "2 or 3",
      tueren_45: "4 or 5",
      sitze_label: "Seats",
      sitze_2: "2",
      sitze_45: "4 to 5",
      sitze_67: "6 to 7",
      sitze_mehr: "more than 7",
      egal: "No preference",
      field_getriebe: "Transmission",
      field_bauart: "Body type",
      field_tueren: "Doors",
      field_sitze: "Seats",

      photos_title: "Vehicle Photos",
      photos_label: "Upload photos *",
      files_none: "No files selected",
      files_count: "{count} file(s): {names}",
      photos_hint:
        "Please upload photos of all sides, interior and any damages (max. 10 images).",
      req_title: "Required photos:",
      req_front: "Front view",
      req_rear: "Rear view",
      req_sides: "Side view (both sides)",
      req_interior: "Interior",
      req_odo: "Odometer (mileage)",
      req_damage: "Any damage or defects",

      contacts_title: "Your Contact Details",
      name_label: "Name *",
      name_ph: "Your name",
      email_label: "Email",
      email_ph: "Your email",
      phone_label: "Phone",
      kontaktweg_hinweis: "Phone or email is enough - I need one of the two to get back to you.",
      phone_ph: "Your phone number",
      location_label: "City/ZIP *",
      land_label: "Country *",
      land_placeholder: "Please select",
      land_de: "Germany",
      land_ch: "Switzerland",
      land_fr: "France",
      land_other: "Other country",
      location_ph: "Your location",
      message_label: "Message (optional)",
      message_ph: "Additional info or appointment requests...",
      privacy_prefix: "Data protection notice: I use your details only to process your inquiry. Details are in the",
      privacy_link: "privacy policy",
      privacy_suffix: ".",

      btn_sending: "Sending…",
      btn_submit_purchase: "Request free valuation",
      btn_submit_wish: "Request free car search",

      alert_max10:
        "Please upload a maximum of 10 images. Only the first 10 will be used.",
      err_brand: "Please select a brand.",
      err_brand_other: "Please enter the brand.",
      err_model_other: "Please enter the model.",
      err_model: "Please select a model.",
      err_year_range: "Year must be between {min} and {max}.",
      err_mileage: "Mileage is invalid.",
      err_price: "Please provide a valid expected price.",
      err_images_required: "Please upload at least one vehicle photo.",
      err_contacts: "Please fill in name, city/ZIP and country.",
      err_kontaktweg: "Please provide phone OR email so I can get back to you.",
      err_privacy: "Please accept the privacy policy.",
      err_webhook: "Sending failed. Please try again later, or use WhatsApp / phone.",
      err_generic: "Sending failed. Please try again later, or use WhatsApp / phone.",
      success_alert: "Thank you, your request has arrived. I will get back to you.",
      warn_only_first10:
        "Only the first 10 images will be attached.",
      brand_other_fallback: "Other",

      embed: {
        title_purchase: "Purchase Request",
        title_wish: "Dream Car Request",
        service_name: "Service",
      },
      service_purchase_full: "Purchase (sell a car)",
      service_wish_full: "Mediation (dream car)",

      field_brand: "Brand",
      field_model: "Model",
      field_year: "Year",
      field_mileage: "Mileage",
      field_price: "Expected price",
      field_budget: "Budget",
      field_color: "Color",
      field_fuel: "Fuel",
      field_equipment: "Equipment",
      field_name: "Name",
      field_phone: "Phone",
      field_email: "Email",
      field_location: "City/ZIP",
      field_land: "Country",
      field_message: "Message",

      discord_content_purchase: "New purchase request",
      discord_content_wish: "New dream car request",
    },

    // ===== GeneralForm (NEW) =====
    generalform: {
      heading_intro: "What can I help you with?",
      topic_label: "Topic *",
      topic_placeholder: "Please select",
      topic_zoll: "Customs, papers & registration",
      topic_zoll_hilfe: "Import, clearance, registration, process",
      topic_sonstiges: "Something else",
      topic_sonstiges_hilfe: "Anything that does not fit here",
      topic_ankauf: "Sell your car",
      topic_ankauf_hilfe: "Opens the purchase form",
      topic_wunschauto: "Find a car",
      topic_wunschauto_hilfe: "Opens the vehicle search",

      contacts_title: "Your Contact Details",
      name_label: "Name *",
      name_ph: "Your name",
      email_label: "Email",
      email_ph: "Your email",
      phone_label: "Phone",
      kontaktweg_hinweis: "Phone or email is enough - I need one of the two to get back to you.",
      phone_ph: "Your phone number",
      location_label: "City/ZIP *",
      location_ph: "Your location",
      message_label: "Message (optional)",
      message_ph: "Additional information or appointment requests...",

      privacy_prefix: "Data protection notice: I use your details only to process your inquiry. Details are in the",
      privacy_link: "privacy policy",
      privacy_suffix: ".",

      btn_sending: "Sending…",
      btn_submit: "Send request",

      err_topic: "Please select a topic.",
      err_name: "Please enter your name.",
      err_email: "Please enter your email.",
      err_phone: "Please enter your phone number.",
      err_location: "Please enter your city/ZIP.",
      err_land: "Please choose the country.",
      err_privacy: "Please accept the privacy policy.",
      err_webhook: "Sending failed. Please try again later, or use WhatsApp / phone.",
      err_generic: "Sending failed. Please try again later, or use WhatsApp / phone.",
      success_alert: "Thank you, your request has arrived. I will get back to you.",

      field_topic: "Topic",
      field_name: "Name",
      field_phone: "Phone",
      field_email: "Email",
      field_location: "City/ZIP",
      field_message: "Message",

      embed_title: "New contact request ({topic})",
      discord_content: "New contact request ({topic})",
    },

    // ========= Footer ==========
    footer: {
        quick_contact: "Quick contact",
        brand: "AUTO M.A.H.",
        owner_label: "Owner:",
        owner_name: "Mohamed Ali Hussein",
        address: "Daimlerstr. 10, 79585 Steinen, DE",
        legal: "Legal",
        imprint: "Imprint",
        privacy: "Privacy Policy",
        tos: "Terms & Conditions",
        info: "Info",
        broker_service: "Brokerage service",
        broker_text: "For a requested car I either buy the vehicle myself or act as a broker for a commission.",
        vat_line: "VAT ID (per § 27a UStG): DE402063042",
        bottom_line: "© {year} AUTO M.A.H. – Car import & customs • B2B • Trade • Export • Brokerage",
    },

    // ========== Privacy =========
    privacy: {
        title: "Privacy Policy",
        html: `
            <h2>1. Privacy at a Glance</h2>
            <h3>General Information</h3>
            <p>The following notes provide a simple overview of what happens to your personal data when you visit this website. Personal data is any data by which you can be personally identified. Detailed information on data protection can be found in my privacy policy set out below.</p>

            <h3>Data Collection on This Website</h3>
            <h4>Who is responsible for data collection on this website?</h4>
            <p>Data processing on this website is carried out by the website operator. You can find the operator’s contact details in the section “Notice Regarding the Controller” in this privacy policy.</p>
            <h4>How do I collect your data?</h4>
            <p>On the one hand, your data is collected when you provide it to me. This can be, for example, data that you enter into a contact form.</p>
            <p>Other data is collected automatically or after your consent when visiting the website by my IT systems (e.g., browser, operating system, time of access). The collection of this technical data takes place automatically as soon as you enter this website.</p>
            <h4>What do I use your data for?</h4>
            <p>Part of the data is collected to ensure the error-free provision of the website. There is no analysis of user behavior.</p>
            <h4>What rights do you have regarding your data?</h4>
            <p>You have the right at any time to obtain information about the origin, recipients, and purpose of your stored personal data. You also have the right to request rectification or erasure of this data, to restrict processing, to data portability, and to lodge a complaint with a supervisory authority. You can contact me at any time regarding this or any other questions on the subject of data protection.</p>

            <h3>Analytics Tools and Third-Party Tools</h3>
            <p>I do not use <strong>tracking</strong> or <strong>analytics tools</strong>. There is no profiling and no reach measurement.</p>
            <p>My hosting provider Cloudflare may set its own cookies for technical reasons, for example to protect against automated access. These are not advertising cookies of ours.</p>
            <p>You can use this website without providing personal data unless you write to me voluntarily.</p>

            <h2>2. Hosting</h2>
            <p>I host the content of my website with the following provider:</p>
            <h3>Cloudflare</h3>
            <p>The provider is Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, USA (“Cloudflare”). The website is served via Cloudflare Pages. When you visit my website, server log files may be processed (e.g., IP address, date/time, referrer URL, user agent). Details: <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">Cloudflare Privacy Policy</a>.</p>
            <p>The legal basis is Art. 6(1)(f) GDPR (legitimate interest in a reliable, performant, and secure provision of my website). Cloudflare also processes data in the USA. This transfer is based on the European Commission’s adequacy decision pursuant to Art. 45 GDPR (EU-U.S. Data Privacy Framework); Cloudflare, Inc. is certified under this framework. Cloudflare provides a data processing agreement pursuant to Art. 28 GDPR.</p>

            <h2>3. General Notes and Mandatory Information</h2>
            <h3>Data Protection</h3>
            <p>I treat your personal data confidentially and in accordance with the statutory data protection regulations as well as this privacy policy. Please note that data transmission on the Internet (e.g., communication by email) may have security vulnerabilities.</p>

            <h3>Notice Regarding the Controller</h3>
            <p>Controller: Mohamed Ali Hussein<br>Daimlerstr. 10, 79585 Steinen, Germany</p>
            <p>Phone: +49 (0) 176 960 849 98<br>Email: info@auto-mah.com</p>

            <h3>Storage Period</h3>
            <p>Inquiries submitted via the form are stored at Cloudflare and are <strong>deleted automatically after 12 months at the latest</strong>. If an inquiry is settled before that, I delete it right away. Statutory retention duties (for example after a later contract) remain unaffected. Otherwise personal data remain with me until the purpose ceases or you request deletion.</p>

            <h3>Legal Bases</h3>
            <p>Depending on the case: Art. 6(1)(a) GDPR (consent), Art. 6(1)(b) GDPR (contract/pre-contractual measures), Art. 6(1)(c) GDPR (legal obligation), or Art. 6(1)(f) GDPR (legitimate interests). Consent can be withdrawn at any time with effect for the future.</p>

            <h3>Recipients of Personal Data</h3>
            <p>Personal data will not be disclosed to third parties except where required by law, necessary for contract performance, where my legitimate interests prevail, or where another legal basis permits disclosure.</p>

            <h3>Your Rights</h3>
            <p>Right of access, rectification, erasure, restriction, objection (Art. 21 GDPR), data portability, and the right to lodge a complaint with a supervisory authority. The competent authority is the State Commissioner for Data Protection and Freedom of Information of Baden-Württemberg: <a href="https://www.baden-wuerttemberg.datenschutz.de/" target="_blank" rel="noopener noreferrer">baden-wuerttemberg.datenschutz.de</a>.</p>

            <h3>SSL/TLS Encryption</h3>
            <p>This site uses SSL/TLS encryption. You can recognize an encrypted connection by the “https://” and the lock symbol in the browser’s address bar.</p>

            <h2>4. Data Collection on This Website</h2>
            <h3>Server Log Files</h3>
            <p>Technical data (e.g., browser type/version, operating system, referrer URL, host name, time of server request, IP address) may be processed by the provider. Legal basis: Art. 6(1)(f) GDPR (technical provision).</p>

            <h3>Contact Form</h3>
            <p>If you contact me via the contact form, I process the data you voluntarily enter (e.g., name, phone, email, vehicle details) solely to handle your inquiry and to contact you.</p>
            <p><strong>Transmission of your inquiry:</strong> Your inquiry is received and stored by a service I operate at <strong>Cloudflare</strong> (Cloudflare, Inc., USA); your IP address is processed technically in the process. A data processing agreement pursuant to Art. 28 GDPR is in place with Cloudflare. In my internal chat at <strong>Discord</strong> (Discord Inc., USA) I only receive <strong>a notification</strong> that an inquiry has arrived, with a sequential number and the time. Your name, your contact details, your vehicle details and your photos are <strong>not</strong> transmitted to Discord. Only I can view the inquiry itself; access is protected by an access token and a PIN. Cloudflare also processes data in the USA. The legal basis for this transfer is the European Commission's adequacy decision pursuant to Art. 45 GDPR (EU-U.S. Data Privacy Framework); Cloudflare, Inc. is certified under this framework. No further disclosure to third parties, in particular for advertising purposes, takes place.</p>
            <p>Legal bases: Art. 6(1)(b) GDPR (contract/pre-contract), or Art. 6(1)(f) GDPR (legitimate interest in effective communication), or Art. 6(1)(a) GDPR (consent, if obtained). Data will be deleted upon request or after the communication has been completed; statutory retention obligations remain unaffected.</p>

            <h3>WhatsApp</h3>
            <p>If you write to me via the WhatsApp button, the conversation is processed by WhatsApp Ireland Limited / Meta Platforms. WhatsApp’s privacy notice applies. Legal basis: Art. 6(1)(b) or (f) GDPR (contact that you initiate).</p>

            <h3>Map (Google Maps)</h3>
            <p>On the contact page I show my location as a static map image hosted on this website. No map service is loaded automatically. If you tap the map, you leave my site and open Google Maps (Google Ireland Limited / Google LLC, USA) with the destination for driving directions. Google’s notice then applies: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a>.</p>

            <h3>Language setting</h3>
            <p>Your language choice (DE, EN or FR) is stored only locally in your browser (localStorage, key “lang”) so the site stays in the language you chose. Nothing is analysed. You can delete the entry in your browser settings.</p>

            <h3>Vehicle inquiries</h3>
            <p>If you send photos or vehicle details, I use them only to handle your inquiry. They are not published and not used for advertising.</p>

            <h3>Vehicle registration</h3>
            <p>I only register vehicles in Germany. If I register a vehicle for you, I need the details from your ID document, the eVB number from your insurer, the vehicle papers and, for the vehicle tax, your bank details with a SEPA mandate, plus a power of attorney from you. I use this data solely for the registration and pass it only to the German registration office and the bodies involved there. Once the registration is complete I delete it, unless a statutory retention obligation applies. Legal basis is Art. 6(1)(b) GDPR (contract).</p>

            <h3>Inquiry by Email or Telephone</h3>
            <p>If you contact me by email or telephone, I process your details for the purpose of handling your request. My address info@auto-mah.com is a forwarding address: your message passes through the mail servers of IONOS SE, Montabaur, and is delivered to a mailbox at Microsoft Corporation (Outlook.com). Beyond that I pass nothing on without your consent. Legal bases as above; deletion after the purpose has been fulfilled or upon request.</p>
        `,
    },

    // ======== AGB ========

    tos: {
        title: "Terms and Conditions",
        html: `
            <h3>1. What this site is for</h3>
            <p>
            This website is the digital business card of <strong>AUTO M.A.H.</strong>
            (Owner: Mohamed Ali Hussein). It is for introducing the business and for getting in touch.
            There is no online shop. Nothing is sold or paid for on this site.
            Business takes place off the website: in person, by phone or on site.
            </p>

            <h3>2. What I offer</h3>
            <ul>
            <li><strong>Buying cars:</strong> You can offer me your car for sale.</li>
            <li><strong>Finding a car:</strong> I look for a car if you ask. Depending on the case I buy it myself and sell it on to you, or I only act as a broker and receive a commission if it works out. We agree beforehand which of the two applies.</li>
            <li><strong>Cars on the site:</strong> If I show cars, they are information without a price. That is not a binding offer and not an online sale.</li>
            </ul>

            <h3>3. Inquiry and purchase</h3>
            <p>
            A form, a call or a message is not a contract yet.
            Price and purchase are agreed only in person, by phone or on site.
            </p>
            <p>
            Details about cars on the site (photos, data) are non-binding and may change.
            A purchase contract is only formed off the website.
            There is no distance sale through this site.
            </p>

            <h3>4. Liability</h3>
            <p>
            I take care to keep information correct. I do not guarantee that the website is complete or up to date.
            </p>
            <p>
            I am liable for damages in accordance with the statutory provisions. No limitation of my liability
            is intended.
            </p>

            <h3>5. Consumer dispute resolution</h3>
            <p>
            I am neither obliged nor willing to participate in dispute resolution proceedings
            before a consumer arbitration board.
            </p>

            <h3>6. Data protection</h3>
            <p>
            Data from the form or email is used only for your inquiry.
            Your inquiry is stored at Cloudflare; via Discord I only receive a notification without your data.
            Details are in the <a href="/privacy">Privacy Policy</a>.
            </p>

            <h3>7. Final provisions</h3>
            <p>
            German law applies. If the customer is a merchant, a legal entity under public law or a special
            fund under public law, the place of jurisdiction is Lörrach. For consumers the statutory places
            of jurisdiction apply.
            </p>
        `,
    },

    // =========== Impressum ===========

    imprint: {
        title: "Legal Notice (Imprint)",
        html: `
            <p><strong>AUTO M.A.H.</strong><br>
            Owner: Mohamed Ali Hussein</p>

            <p>
            Daimlerstr. 10<br>
            79585 Steinen, Germany
            </p>

            <p>
            Phone: <a href="tel:+4917696084998">+49 176 96084998</a><br>
            Email: <a href="mailto:info@auto-mah.com">info@auto-mah.com</a>
            </p>

            <p>
            VAT ID (pursuant to § 27a German VAT Act):<br>
            <strong>DE402063042</strong>
            </p>

            <p>Information pursuant to Section 5 of the German Digital Services Act (DDG).</p>

            <p>
            This website is for getting in touch. Vehicle contracts are not concluded through the website.
            </p>

            <p><strong>Editorially responsible (Sec. 18 (2) MStV):</strong><br>
            Mohamed Ali Hussein, Daimlerstr. 10, 79585 Steinen
            </p>

            <h3>Consumer Dispute Resolution</h3>
            <p>
            I am neither obliged nor willing to participate in dispute resolution proceedings
            before a consumer arbitration board.
            </p>

            <h3>Hosting</h3>
            <p>
            This website is provided by Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, USA
            (Cloudflare Pages). Details on data processing are set out in the
            <a href="/privacy">Privacy Policy</a>.
            </p>
        `,
    },




  },

  fr: {

    // ======================
    // Page regionale Suisse (/auto-verkaufen-schweiz)
    // ======================
    chpage: {
      meta_title: "Vendre sa voiture en Suisse | Achat et dédouanement | AUTO M.A.H.",
      meta_desc: "Vous voulez vendre votre voiture en Suisse ? Je l’achète et je m’occupe moi-même de l’exportation et du dédouanement. Estimation gratuite, région de Bâle, Argovie, Soleure, Berne et Zurich.",
      h1: "Vendre sa voiture en Suisse",
      lead: "Votre voiture se trouve en Suisse et vous voulez la vendre. Je l’achète et je viens la chercher. Le passage de la frontière, c’est mon affaire.",
      cta: "Proposer un véhicule",
      cta_hint: "Gratuit et sans engagement. Une demande ne vous engage à rien.",

      why_title: "Pourquoi me vendre votre voiture",
      why1_title: "Je fais le dédouanement moi-même",
      why1_text: "Je ne confie pas le dédouanement à un transitaire. Comme je le fais en permanence pour mes propres véhicules, je connais les règles et les papiers nécessaires par la pratique.",
      why2_title: "Le chemin est court",
      why2_text: "Je suis installé à Steinen, dans le triangle des trois pays, juste à la frontière. Je peux être chez vous rapidement.",
      why3_title: "Dans le commerce automobile depuis 2007",
      why3_text: "Je suis indépendant dans le commerce automobile depuis 2007 et je ne suis pas un intermédiaire qui doit encore chercher un acheteur pour votre voiture.",
      why4_title: "Regarder d’abord, décider ensuite",
      why4_text: "Tout reste gratuit et sans engagement jusqu’à ce que nous soyons d’accord après l’inspection.",

      zoll_title: "Ce que la douane vient faire là-dedans",
      zoll_p1: "Sur le plan douanier, la Suisse est un pays tiers. Lorsqu’un véhicule passe de là vers l’Allemagne, on compte en règle générale 10 pour cent de droits de douane et 19 pour cent de TVA à l’importation.",
      zoll_p2: "C’est là que beaucoup d’acheteurs allemands renoncent. Pour moi c’est la routine : je déclare et j’importe le véhicule moi-même. Pour vous, le vendeur, rien ne change au déroulement.",
      zoll_hinweis: "Information générale donnée au mieux de mes connaissances, ni conseil juridique ni conseil fiscal. Chaque cas peut différer, demandez-moi simplement.",

      ablauf_title: "Comment cela se passe",
      area_title: "Où j’achète en Suisse",
      area_lead: "Plus loin n’est pas un problème, contactez-moi.",
      area_list: ["Région de Bâle", "Canton d’Argovie", "Canton de Soleure", "Canton de Berne", "Canton de Zurich"],

      was_title: "Ce dont vous avez besoin",
      was_lead: "En bref : très peu. Je me charge de la plus grande partie.",
      sie_title: "Pour un véhicule suisse, il vous faut",
      was1_title: "Permis de circulation",
      was1_text: "C’est la seule chose que vous devez tenir prête vous-même.",
      was2_title: "Contrat de vente",
      was2_text: "Nous l’établissons ensemble dès que nous sommes d’accord sur le prix.",
      andere_text: "Un autre cas ? Un véhicule allemand qui se trouve en Suisse, une voiture de société ou un véhicule de marchand : contactez-moi, je connais aussi ce chemin.",
      rest_title: "Ce dont je m’occupe",
      rest1_title: "Annulation",
      rest1_text: "Je me charge de l’annulation du véhicule.",
      rest2_title: "Transport",
      rest2_text: "Je viens avec un transporteur et je récupère le véhicule chez vous. Vous n’avez à vous déplacer nulle part.",
      rest3_title: "Importation en Allemagne",
      rest3_text: "L’exportation, le dédouanement et l’importation sont mon affaire. Vous n’avez rien à y faire.",
      schluss_title: "Vous avez un véhicule ?",
      schluss_text: "Envoyez-moi les données principales et quelques photos. Je reviens vers vous avec une estimation honnête.",
    },
    nav_home: "Accueil",
    nav_services: "Services",
    nav_purchase: "Achat Véhicule",
    nav_cars: "Véhicules",
    nav_cta: "Vendre ma voiture",
    nav_about: "À propos de moi",
    nav_contact: "Contact",

    global: {
      demo_submit_info:
        "Merci ! Votre demande a été enregistrée (démo). Veuillez connecter un backend.",
    },

    nf: {
      titel: "Cette page n'existe pas",
      text: "Le lien ne mène nulle part. Peut-être une faute de frappe, peut-être une ancienne adresse.",
      start: "Aller à l'accueil",
      hilfe: "Vous cherchez quelque chose de précis ? Appelez-moi :",
    },
    hero: {
      title: "Achat et importation de véhicules en Allemagne, en Suisse et en France",
      subtitle:
        "Au cœur des Trois Frontières • Achat DE · CH · FR • Dédouanement • Immatriculation • Export UE",
      cta: "Demander un achat maintenant",
      cta_whatsapp: "WhatsApp",
      whatsapp_text: "Bonjour, je souhaite vendre ma voiture.",
      cta_anruf: "Appeler",
      schliessen: "Fermer",
      badge_fair: "Prix équitables",
      badge_fast: "Traitement rapide",
      badge_pro: "Dédouanement en propre",
      badge_wish: "Service voiture de rêve",
    },

    services: {
      title: "Mes services",
      card1: {
        title: "Achat de véhicules Allemagne, Suisse & France",
        text: "J'achète des véhicules de haute qualité directement sur les marchés allemand, suisse et français - prix équitables, traitement rapide",
      },
      card2: {
        title: "Import & Dédouanement",
        text: "J'importe et dédouane moi-même mes véhicules venant de Suisse, sans transitaire. Vous achetez une voiture déjà entièrement importée.",
      },
      card3: {
        title: "Immatriculation allemande & Contrôle TÜV",
        text: "Service et contrôle technique principal TÜV - véhicule prêt à la vente",
      },
      card4: {
        title: "Commerce & Distribution",
        text: "Vente de véhicules importés sur le marché allemand ou export vers les pays de l'UE",
      },
      card5: {
        title: "Service voiture de rêve",
        text: "Vous cherchez un véhicule spécifique ? Je le trouve selon vos critères - marque, équipement, budget. En France comme à l'étranger.",
      },
      card6: {
        title: "Recherche de véhicule sur mesure",
        text: "Recherche ciblée de votre voiture idéale avec des exigences spécifiques d'équipement et de budget",
      },
    },

    faq: {
      title: "Questions fréquentes",
      subtitle: "Ce que les acheteurs et les vendeurs me demandent le plus souvent.",
      hinweis: "Information générale donnée en toute bonne foi, sans valeur de conseil juridique ou fiscal. Chaque cas peut différer, n'hésitez pas à me demander.",
      q1: "Vos véhicules venant de Suisse sont-ils correctement importés ?",
      a1: "Oui. Sur le plan douanier, la Suisse est un pays tiers : en règle générale, 10 % de droits de douane et 19 % de TVA à l'importation s'appliquent. Je réalise moi-même le dédouanement, sans transitaire. Je ne remets un véhicule qu'une fois l'importation terminée et les documents douaniers disponibles.",
      q2: "Qu'est-ce que cela signifie pour moi en tant qu'acheteur ?",
      a2: "Vous recevez un véhicule dont l'importation est terminée et dont les documents sont complets. Ce qui est nécessaire pour l'immatriculation, je le passe en revue avec vous à l'avance, tout comme l'état du contrôle technique et du contrôle des gaz d'échappement. Nous le consignons par écrit pour votre véhicule.",
      q3: "Vendez-vous aussi à des professionnels ou à l'étranger dans l'UE ?",
      a3: "Oui. Je vends à des particuliers en Allemagne, à des marchands, et j'exporte vers d'autres pays de l'UE. Parlez-moi de votre situation, des conditions particulières s'appliquent aux professionnels et à l'export.",
      q4: "Je souhaite vendre ma voiture. Comment cela se passe-t-il ?",
      a4: "Vous m'envoyez les données principales et quelques photos, via le formulaire, WhatsApp ou par téléphone. Je reviens vers vous avec une estimation honnête. Ce n'est qu'une fois d'accord après la visite que l'affaire se conclut. Jusque-là, tout est sans engagement et gratuit.",
      q5: "Je vends depuis la Suisse. Que dois-je faire ?",
      a5: "Vous n’avez besoin que du permis de circulation, nous établissons le contrat de vente ensemble. L’annulation, le transport et l’importation en Allemagne sont mon affaire. Vous n’avez à vous déplacer nulle part.",
      a5_link: "Tout à ce sujet : vendre sa voiture en Suisse",
    },

    ablauf: {
      title: "Vous voulez vendre votre voiture ?",
      subtitle: "Voici comment se déroule le rachat. Quatre étapes, sans risque : tout reste sans engagement jusqu'à l'accord.",
      s1_title: "Envoyer la demande",
      s1_text: "Via le formulaire, WhatsApp ou par téléphone. Des photos m'aident à évaluer le véhicule. Sans engagement et gratuit.",
      s2_title: "Recevoir l'estimation",
      s2_text: "J'examine vos indications et je reviens vers vous avec une estimation honnête et une proposition de prix.",
      s3_title: "Visite & accord",
      s3_text: "Nous examinons le véhicule ensemble. Ce n'est qu'une fois d'accord que la demande devient une affaire.",
      s4_title: "Vente & remise",
      s4_text: "Nous nous mettons d'accord, vous recevez votre argent et je reprends le véhicule avec ses documents. Tout le reste est mon affaire.",
    },

    purchase: {
      title: "Achat de véhicule & Médiation",
      subtitle:
        "J'achète votre véhicule directement ou je vous aide à trouver votre voiture idéale",
      offer_two_services: "Je propose deux services :",
      feature_buy: {
        title: "Achat de véhicule",
        text: "J'achète votre voiture à des conditions équitables",
      },
      feature_wish: {
        title: "Service voiture de rêve",
        text: "Je trouve votre voiture idéale selon vos spécifications",
      },
      feature_note:
        "Que ce soit pour vendre ou acheter – je vous fais une offre équitable et je trouve votre véhicule idéal !",

      accept_all_title:
        "J'achète des occasions de toutes marques et modèles",
      accept_high_mileage: "Même avec un kilométrage élevé",
      accept_defects: "Véhicules avec défauts ou dommages",
      accept_accident: "Véhicules accidentés",
      accept_total_loss: "Perte totale économique",
      accept_young_old: "Véhicules jeunes et anciens",
      accept_luxury_daily: "Véhicules de luxe & du quotidien",
      accept_with_without_history:
        "Avec ou sans historique d'entretien",
      fair_offer_any_condition:
        "Quel que soit l'état – je vous fais une offre équitable !",
    },

    cars: {
      title: "Véhicules",
      lead: "Vous cherchez une voiture ? Demandez-moi. Le prix, je vous le dis en direct. L’achat se fait chez moi, pas sur le site.",
      price: "Prix sur demande",
      btn: "Me demander",
      open: "Voir les véhicules",
      soon: "Pas encore de voitures ici",
      soon_text: "Pour l'instant, rien n'est en ligne. Si vous cherchez quelque chose, écrivez-moi. Je verrai ce que je peux trouver.",
      anfrage_text: "Demande pour le véhicule : {auto}",
    },

    about: {
      title: "À propos d'AUTO M.A.H.",
      owner_alt: "Propriétaire AUTO M.A.H.",
      owner_name: "Mohamed Ali Hussein",
      owner_role: "Propriétaire & Directeur Général",
      qr_text: "ENVOYER PHOTO · RECEVOIR OFFRE",
      headline:
        "Votre spécialiste de l'achat et de l'importation de véhicules dans la région des Trois Frontières",
      p1: "Je suis indépendant dans le commerce automobile depuis 2007. Aujourd'hui je suis à Steinen, au cœur des Trois Frontières. D'ici je suis vite en Allemagne, en Suisse et en France. Les voitures venant de Suisse, je les dédouane selon les règles allemandes, puis je les vends en Allemagne ou dans l'UE.",
      p2: "Je réalise moi-même le dédouanement au lieu de le confier à un transitaire. Comme je le fais en permanence pour mes propres véhicules, je connais la réglementation allemande et les documents nécessaires par la pratique, et non par les manuels. Le trajet de la Suisse vers l'Allemagne en devient court et prévisible.",
      new_wish_service_title: "Service voiture de rêve",
      new_wish_service_text:
        "Vous cherchez une voiture précise, avec un équipement précis ? Je la cherche pour vous, ici et à l'étranger.",
      note_strong:
        "Vous avez des questions sur l'importation de voitures ou recherchez un véhicule spécifique ?",
      note_text:
        "Je vous conseille volontiers sur tous les sujets liés à l'importation de véhicules, au dédouanement et à la recherche automobile individuelle.",
    },

    contact: {
      title: "Contactez-moi volontiers",
      brand: "AUTO M.A.H.",
      map_title: "Adresse Daimlerstraße 10, Steinen. Ouvre l'itinéraire dans Google Maps.",
      hours_title: "Demandes à tout moment",
      hours_main: "Formulaire, WhatsApp ou e-mail, 24h/24",
      area_title: "Où j'achète des véhicules",
      area_lead: "J'achète dans toute la région des trois frontières. Plus loin ne pose aucun problème, parlez-m'en.",
      area_regions: [
        { land: "Allemagne", gebiete: ["Arrondissement de Lörrach", "Arrondissement de Waldshut", "Région de Fribourg"] },
        { land: "Suisse", gebiete: ["Région de Bâle", "Canton d'Argovie", "Canton de Soleure", "Canton de Berne", "Canton de Zurich"] },
        { land: "France", gebiete: ["Alsace"] },
      ],
      area_ch_link: "Vous vendez depuis la Suisse ? Comment se passe l’achat au-delà de la frontière",
    },

    vehicle: {
      max_5_images:
        "Veuillez télécharger au maximum 5 images. Seules les 5 premières seront prises en compte.",
    },

    // ======================
    // CarForm (NOUVEAU)
    // ======================
    carform: {
      title: "Vendre un véhicule ou demander une voiture souhaitée",
      service_title: "Quel service désirez-vous ?",
      service_purchase: "Vendre un véhicule (Achat)",
      service_wish: "Trouver un véhicule (Médiation)",

      vehicle_title: "Données du véhicule",
      brand_label: "Marque *",
      brand_placeholder: "Veuillez choisir",
      brand_other_label: "Marque personnalisée *",
      brand_other_ph: "ex. Alfa Romeo",
      model_label: "Modèle *",
      model_placeholder: "Veuillez choisir un modèle",
      model_first_choose: "Veuillez d’abord choisir une marque",
      model_other_label: "Modèle *",
      model_other_ph: "ex. Giulia",
      year_label: "Année *",
      year_ph: "ex. {example}",
      mileage_label: "Kilométrage *",
      mileage_ph: "ex. 75000",

      price_title: "Prix souhaité",
      price_label: "Votre prix souhaité *",
      currency_label: "Devise",
      price_ph: "Quel prix avez-vous en tête ?",

      budget_title: "Budget",
      budget_label: "Votre budget",
      budget_ph: "Quel est votre budget maximum ?",

      features_title: "Équipements souhaités",
      optional_marke: "facultatif",
      equipment_label: "Souhaits d’équipement particuliers",
      equipment_ph:
        "ex. cuir, toit panoramique, options spéciales...",
      color_label: "Couleur préférée",
      color_ph: "Couleur du véhicule",
      fuel_label: "Type de carburant",
      fuel_placeholder: "Veuillez choisir",
      fuel_petrol: "Essence",
      fuel_diesel: "Diesel",
      fuel_hybrid: "Hybride",
      fuel_electric: "Électrique",
      fuel_any: "Peu importe",
      getriebe_label: "Boîte de vitesses",
      getriebe_auto: "Automatique",
      getriebe_hand: "Manuelle",
      bauart_label: "Type de carrosserie",
      bauart_limousine: "Berline",
      bauart_kombi: "Break",
      bauart_suv: "SUV / tout-terrain",
      bauart_coupe: "Coupé",
      bauart_cabrio: "Cabriolet",
      bauart_klein: "Petite voiture",
      bauart_van: "Monospace / minibus",
      bauart_pickup: "Pick-up",
      tueren_label: "Portes",
      tueren_23: "2 ou 3",
      tueren_45: "4 ou 5",
      sitze_label: "Places assises",
      sitze_2: "2",
      sitze_45: "4 à 5",
      sitze_67: "6 à 7",
      sitze_mehr: "plus de 7",
      egal: "Peu importe",
      field_getriebe: "Boîte de vitesses",
      field_bauart: "Carrosserie",
      field_tueren: "Portes",
      field_sitze: "Places assises",

      photos_title: "Photos du véhicule",
      photos_label: "Téléverser des photos *",
      files_none: "Aucun fichier sélectionné",
      files_count: "{count} fichier(s) : {names}",
      photos_hint:
        "Veuillez téléverser des photos de tous les côtés, de l’intérieur et d’éventuels dommages (10 images max.).",
      req_title: "Photos requises :",
      req_front: "Vue avant",
      req_rear: "Vue arrière",
      req_sides: "Vue latérale (les deux côtés)",
      req_interior: "Intérieur",
      req_odo: "Compteur (kilométrage)",
      req_damage: "Éventuels dommages ou défauts",

      contacts_title: "Vos coordonnées",
      name_label: "Nom *",
      name_ph: "Votre nom",
      email_label: "E-mail",
      email_ph: "Votre e-mail",
      phone_label: "Téléphone",
      kontaktweg_hinweis: "Téléphone ou e-mail suffit - il m'en faut un des deux pour vous répondre.",
      phone_ph: "Votre numéro de téléphone",
      location_label: "Ville/Code postal *",
      land_label: "Pays *",
      land_placeholder: "Veuillez choisir",
      land_de: "Allemagne",
      land_ch: "Suisse",
      land_fr: "France",
      land_other: "Autre pays",
      location_ph: "Votre localité",
      message_label: "Message (facultatif)",
      message_ph:
        "Informations supplémentaires ou demande de rendez-vous...",
      privacy_prefix: "Protection des données : je n’utilise vos informations que pour traiter votre demande. Les détails figurent dans la",
      privacy_link: "politique de confidentialité",
      privacy_suffix: ".",

      btn_sending: "Envoi…",
      btn_submit_purchase: "Demander une estimation gratuite",
      btn_submit_wish: "Demander une recherche de véhicule",

      alert_max10:
        "Veuillez téléverser au maximum 10 images. Seules les 10 premières seront utilisées.",
      err_brand: "Veuillez choisir une marque.",
      err_brand_other: "Veuillez saisir la marque.",
      err_model_other: "Veuillez saisir le modèle.",
      err_model: "Veuillez choisir un modèle.",
      err_year_range:
        "L’année doit être comprise entre {min} et {max}.",
      err_mileage: "Le kilométrage est invalide.",
      err_price:
        "Veuillez indiquer un prix souhaité valide.",
      err_images_required:
        "Veuillez téléverser au moins une photo du véhicule.",
      err_contacts:
        "Veuillez renseigner nom, ville/CP et pays.",
      err_kontaktweg:
        "Indiquez téléphone OU e-mail pour que je puisse vous répondre.",
      err_privacy:
        "Veuillez accepter la politique de confidentialité.",
      err_webhook: "L’envoi a échoué. Réessayez plus tard ou via WhatsApp / téléphone.",
      err_generic: "L’envoi a échoué. Réessayez plus tard ou via WhatsApp / téléphone.",
      success_alert:
        "Merci, votre demande est arrivée. Je vous recontacte.",
      warn_only_first10:
        "Seules les 10 premières images seront jointes.",
      brand_other_fallback: "Autre",

      embed: {
        title_purchase: "Demande d’achat",
        title_wish: "Demande de voiture souhaitée",
        service_name: "Service",
      },
      service_purchase_full: "Achat (vendre un véhicule)",
      service_wish_full: "Médiation (voiture souhaitée)",

      field_brand: "Marque",
      field_model: "Modèle",
      field_year: "Année",
      field_mileage: "Kilométrage",
      field_price: "Prix souhaité",
      field_budget: "Budget",
      field_color: "Couleur",
      field_fuel: "Carburant",
      field_equipment: "Équipement",
      field_name: "Nom",
      field_phone: "Téléphone",
      field_email: "E-mail",
      field_location: "Ville/CP",
      field_land: "Pays",
      field_message: "Message",

      discord_content_purchase: "Nouvelle demande d’achat",
      discord_content_wish:
        "Nouvelle demande de voiture souhaitée",
    },

    // ===== GeneralForm (NOUVEAU) =====
    generalform: {
      heading_intro: "Sur quel sujet puis-je vous aider ?",
      topic_label: "Sujet *",
      topic_placeholder: "Veuillez choisir",
      topic_zoll: "Douane, papiers & immatriculation",
      topic_zoll_hilfe: "Importation, dédouanement, immatriculation, déroulement",
      topic_sonstiges: "Autre chose",
      topic_sonstiges_hilfe: "Tout ce qui n'entre pas dans les cases",
      topic_ankauf: "Vendre ma voiture",
      topic_ankauf_hilfe: "Ouvre le formulaire de rachat",
      topic_wunschauto: "Trouver une voiture",
      topic_wunschauto_hilfe: "Ouvre la recherche de véhicule",

      contacts_title: "Vos coordonnées",
      name_label: "Nom *",
      name_ph: "Votre nom",
      email_label: "E-mail",
      email_ph: "Votre e-mail",
      phone_label: "Téléphone",
      kontaktweg_hinweis: "Téléphone ou e-mail suffit - il m'en faut un des deux pour vous répondre.",
      phone_ph: "Votre numéro de téléphone",
      location_label: "Ville/CP *",
      location_ph: "Votre localité",
      message_label: "Message (facultatif)",
      message_ph: "Informations supplémentaires ou demandes de rendez-vous...",

      privacy_prefix: "Protection des données : je n’utilise vos informations que pour traiter votre demande. Les détails figurent dans la",
      privacy_link: "politique de confidentialité",
      privacy_suffix: ".",

      btn_sending: "Envoi…",
      btn_submit: "Envoyer la demande",

      err_topic: "Veuillez choisir un sujet.",
      err_name: "Veuillez indiquer votre nom.",
      err_email: "Veuillez indiquer votre e-mail.",
      err_phone: "Veuillez indiquer votre numéro de téléphone.",
      err_location: "Veuillez indiquer votre ville/CP.",
      err_land: "Veuillez choisir le pays.",
      err_privacy: "Veuillez accepter la politique de confidentialité.",
      err_webhook: "L’envoi a échoué. Réessayez plus tard ou via WhatsApp / téléphone.",
      err_generic: "L’envoi a échoué. Réessayez plus tard ou via WhatsApp / téléphone.",
      success_alert: "Merci, votre demande est arrivée. Je vous recontacte.",

      field_topic: "Sujet",
      field_name: "Nom",
      field_phone: "Téléphone",
      field_email: "E-mail",
      field_location: "Ville/CP",
      field_message: "Message",

      embed_title: "Nouvelle demande de contact ({topic})",
      discord_content: "Nouvelle demande de contact ({topic})",
    },

        // ========= Footer ==========
    footer: {
        quick_contact: "Contact rapide",
        brand: "AUTO M.A.H.",
        owner_label: "Propriétaire :",
        owner_name: "Mohamed Ali Hussein",
        address: "Daimlerstr. 10, 79585 Steinen, DE",
        legal: "Mentions légales",
        imprint: "Mentions légales",
        privacy: "Politique de confidentialité",
        tos: "Conditions générales",
        info: "Infos",
        broker_service: "Service de médiation",
        broker_text: "Pour une voiture souhaitée, soit je l’achète moi-même, soit j’interviens comme intermédiaire contre commission.",
        vat_line: "N° de TVA (conformément au § 27a UStG) : DE402063042",
        bottom_line: "© {year} AUTO M.A.H. – Import & dédouanement automobiles • B2B • Commerce • Export • Médiation",
    },

    // ====== Privacy ======
    privacy: {
        title: "Politique de Confidentialité",
        html: `
            <h2>1. Protection des données en un coup d’œil</h2>
            <h3>Informations générales</h3>
            <p>Les informations ci-dessous donnent un aperçu simple de ce qu’il advient de vos données personnelles lorsque vous visitez ce site web. Les données personnelles sont toutes les données permettant de vous identifier personnellement. Des informations détaillées sur la protection des données figurent dans ma politique de confidentialité ci-après.</p>

            <h3>Collecte des données sur ce site</h3>
            <h4>Qui est responsable de la collecte des données sur ce site&nbsp;?</h4>
            <p>Le traitement des données sur ce site est effectué par l’exploitant du site. Vous trouverez ses coordonnées dans la section «&nbsp;Information concernant le responsable du traitement&nbsp;» de la présente politique de confidentialité.</p>
            <h4>Comment est-ce que je collecte vos données&nbsp;?</h4>
            <p>Vos données sont d’une part collectées lorsque vous me les communiquez. Il peut s’agir, par exemple, des données que vous saisissez dans un formulaire de contact.</p>
            <p>D’autres données sont collectées automatiquement ou après votre consentement lors de votre visite du site par mes systèmes informatiques (p.&nbsp;ex. navigateur, système d’exploitation, heure de consultation). La collecte de ces données techniques intervient automatiquement dès que vous accédez à ce site.</p>
            <h4>À quelles fins est-ce que j’utilise vos données&nbsp;?</h4>
            <p>Une partie des données est collectée afin de garantir la mise à disposition sans erreur du site. Aucune analyse du comportement des utilisateurs n’a lieu.</p>
            <h4>Quels sont vos droits relatifs à vos données&nbsp;?</h4>
            <p>Vous avez le droit, à tout moment, d’obtenir des informations sur l’origine, les destinataires et la finalité de vos données personnelles enregistrées. Vous avez également le droit de demander la rectification ou l’effacement de ces données, la limitation du traitement, la portabilité des données ainsi que le droit d’introduire une réclamation auprès d’une autorité de contrôle. Vous pouvez me contacter à tout moment à ce sujet et pour toute autre question relative à la protection des données.</p>

            <h3>Outils d’analyse et outils de tiers</h3>
            <p>Je n’utilise <strong>aucun suivi</strong> et <strong>aucun outil d’analyse</strong>. Il n’y a pas de profilage ni de mesure d’audience.</p>
            <p>L’hébergeur Cloudflare peut déposer ses propres cookies pour des raisons techniques, par exemple pour se protéger contre les accès automatisés. Ce ne sont pas des cookies publicitaires de ma part.</p>
            <p>Vous pouvez utiliser ce site sans fournir de données personnelles, sauf si vous m’écrivez volontairement.</p>

            <h2>2. Hébergement</h2>
            <p>J’héberge le contenu de mon site auprès du prestataire suivant&nbsp;:</p>
            <h3>Cloudflare</h3>
            <p>Le prestataire est Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, USA («&nbsp;Cloudflare&nbsp;»). Le site est fourni via Cloudflare Pages. Lors de votre visite, des journaux serveurs peuvent être traités (p.&nbsp;ex. adresse IP, date/heure, URL référente, user-agent). Détails&nbsp;: <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">Politique de confidentialité de Cloudflare</a>.</p>
            <p>Base juridique&nbsp;: art. 6, par. 1, point f) du RGPD (intérêt légitime à une mise à disposition fiable, performante et sécurisée). Cloudflare traite également des données aux États-Unis. Ce transfert repose sur la décision d’adéquation de la Commission européenne au titre de l’art. 45 du RGPD (EU-U.S. Data Privacy Framework)&nbsp;; Cloudflare, Inc. est certifié dans ce cadre. Cloudflare met à disposition un contrat de sous-traitance conformément à l’art. 28 du RGPD.</p>

            <h2>3. Informations générales et mentions obligatoires</h2>
            <h3>Protection des données</h3>
            <p>Je traite vos données personnelles de manière confidentielle et conformément aux dispositions légales en vigueur ainsi qu’à la présente politique de confidentialité. Veuillez noter que la transmission de données sur Internet (par ex. par e-mail) peut présenter des failles de sécurité.</p>

            <h3>Information concernant le responsable du traitement</h3>
            <p>Responsable&nbsp;: Mohamed Ali Hussein<br>Daimlerstr. 10, 79585 Steinen, Allemagne</p>
            <p>Téléphone&nbsp;: +49 (0) 176 960 849 98<br>E-mail&nbsp;: info@auto-mah.com</p>

            <h3>Durée de conservation</h3>
            <p>Les demandes envoyées via le formulaire sont conservées chez Cloudflare et <strong>supprimées automatiquement au plus tard au bout de 12 mois</strong>. Si une demande est traitée avant, je la supprime immédiatement. Les obligations légales de conservation (par exemple après un contrat ultérieur) restent réservées. Pour le reste, les données restent chez moi jusqu’à ce que la finalité cesse ou que vous demandiez leur suppression.</p>

            <h3>Bases juridiques</h3>
            <p>Selon les cas&nbsp;: art. 6, par. 1, point a) du RGPD (consentement), point b) (contrat/pré-contrat), point c) (obligation légale) ou point f) (intérêts légitimes). Les consentements peuvent être retirés à tout moment avec effet pour l’avenir.</p>

            <h3>Destinataires des données personnelles</h3>
            <p>Aucune transmission à des tiers n’a lieu, sauf si la loi l’exige, si cela est nécessaire à l’exécution d’un contrat, si mes intérêts légitimes prévalent ou si une autre base juridique l’autorise.</p>

            <h3>Vos droits</h3>
            <p>Droit d’accès, de rectification, d’effacement, de limitation, d’opposition (art. 21 RGPD), de portabilité des données, et droit d’introduire une réclamation auprès d’une autorité de contrôle. L’autorité compétente est le délégué à la protection des données du Bade-Wurtemberg&nbsp;: <a href="https://www.baden-wuerttemberg.datenschutz.de/" target="_blank" rel="noopener noreferrer">baden-wuerttemberg.datenschutz.de</a>.</p>

            <h3>Chiffrement SSL/TLS</h3>
            <p>Ce site utilise un chiffrement SSL/TLS. Vous pouvez reconnaître une connexion chiffrée au «&nbsp;https://&nbsp;» et à l’icône de cadenas dans la barre d’adresse du navigateur.</p>

            <h2>4. Collecte des données sur ce site</h2>
            <h3>Journaux serveurs</h3>
            <p>Des données techniques (p.&nbsp;ex. type/version du navigateur, système d’exploitation, URL référente, nom d’hôte, heure de la requête serveur, adresse IP) peuvent être traitées par le prestataire. Base juridique&nbsp;: art. 6, par. 1, point f) du RGPD (fourniture technique).</p>

            <h3>Formulaire de contact</h3>
            <p>Si vous me contactez via le formulaire de contact, je traite les données que vous saisissez volontairement (p.&nbsp;ex. nom, téléphone, e-mail, détails du véhicule) uniquement afin de traiter votre demande et de vous recontacter.</p>
            <p><strong>Transmission de votre demande&nbsp;:</strong> Votre demande est reçue et conservée par un service que j’exploite chez <strong>Cloudflare</strong> (Cloudflare, Inc., États-Unis)&nbsp;; votre adresse IP y est traitée techniquement. Un contrat de sous-traitance au sens de l’art. 28 du RGPD est conclu avec Cloudflare. Dans ma messagerie interne chez <strong>Discord</strong> (Discord Inc., États-Unis), je reçois <strong>uniquement une notification</strong> indiquant qu’une demande est arrivée, avec un numéro d’ordre et l’heure. Votre nom, vos coordonnées, les données du véhicule et vos photos ne sont <strong>pas</strong> transmis à Discord. Seul moi peux consulter la demande elle-même&nbsp;; l’accès est protégé par un identifiant d’accès et un code PIN. Cloudflare traite également des données aux États-Unis. La base juridique de ce transfert est la décision d'adéquation de la Commission européenne au titre de l'art. 45 du RGPD (EU-U.S. Data Privacy Framework)&nbsp;; Cloudflare, Inc. est certifié dans ce cadre. Aucune autre transmission à des tiers, notamment à des fins publicitaires, n'a lieu.</p>
            <p>Bases juridiques&nbsp;: art. 6, par. 1, point b) du RGPD (contrat/pré-contrat), ou point f) (intérêt légitime à une communication efficace), ou point a) (consentement, le cas échéant). Les données sont supprimées sur demande ou après la fin des échanges&nbsp;; les obligations légales de conservation demeurent inchangées.</p>

            <h3>WhatsApp</h3>
            <p>Si vous m’écrivez via le bouton WhatsApp, la conversation est traitée par WhatsApp Ireland Limited / Meta Platforms. Les règles de confidentialité de WhatsApp s’appliquent. Base juridique&nbsp;: art. 6, par. 1, point b) ou f) du RGPD (contact que vous initiez).</p>

            <h3>Carte (Google Maps)</h3>
            <p>Sur la page contact, j’affiche mon adresse sous forme d’image cartographique hébergée sur ce site. Aucun service de cartes n’est chargé automatiquement. Si vous touchez la carte, vous quittez mon site et ouvrez Google Maps (Google Ireland Limited / Google LLC, États-Unis) avec l’adresse de destination. La notice de Google s’applique alors&nbsp;: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">politique de confidentialité de Google</a>.</p>

            <h3>Choix de la langue</h3>
            <p>Votre choix de langue (DE, EN ou FR) est enregistré uniquement dans votre navigateur (localStorage, clé «&nbsp;lang&nbsp;») pour que le site reste dans la langue choisie. Rien n’est analysé. Vous pouvez supprimer cette entrée dans les paramètres du navigateur.</p>

            <h3>Demandes concernant un véhicule</h3>
            <p>Si vous envoyez des photos ou des données de véhicule, je les utilise uniquement pour traiter votre demande. Elles ne sont pas publiées et ne servent pas à la publicité.</p>

            <h3>Immatriculation</h3>
            <p>Je n’immatricule des véhicules qu’en Allemagne. Si j’immatricule un véhicule pour vous, j’ai besoin des données de votre pièce d’identité, du numéro eVB de votre assurance, des documents du véhicule et, pour la taxe sur les véhicules, de vos coordonnées bancaires avec un mandat SEPA, ainsi que d’une procuration de votre part. J’utilise ces données uniquement pour l’immatriculation et je ne les transmets qu’au service allemand des immatriculations et aux organismes concernés. Une fois l’immatriculation terminée, je les supprime, sauf obligation légale de conservation. Base juridique : art. 6, par. 1, point b, du RGPD (contrat).</p>

            <h3>Demande par e-mail ou téléphone</h3>
            <p>Si vous me contactez par e-mail ou par téléphone, je traite vos informations aux fins du traitement de votre demande. Mon adresse info@auto-mah.com est une redirection&nbsp;: votre message transite par les serveurs de messagerie d’IONOS SE, Montabaur, et est remis dans une boîte aux lettres chez Microsoft Corporation (Outlook.com). Au-delà, je ne transmets rien sans votre consentement. Bases juridiques comme ci-dessus&nbsp;; suppression après réalisation de la finalité ou sur demande.</p>
        `,
    },

    // ======== AGB =========
    tos: {
        title: "Conditions Générales (CGV)",
        html: `
            <h3>1. À quoi sert ce site</h3>
            <p>
            Ce site est la carte de visite numérique d’<strong>AUTO M.A.H.</strong>
            (propriétaire : Mohamed Ali Hussein). Il sert à se présenter et à prendre contact.
            Il n’y a pas de boutique en ligne. Rien n’est vendu ni payé sur le site.
            L’activité se passe hors du site : en personne, par téléphone ou sur place.
            </p>

            <h3>2. Ce que je propose</h3>
            <ul>
            <li><strong>Achat de véhicules :</strong> vous pouvez me proposer votre voiture à l’achat.</li>
            <li><strong>Voiture souhaitée :</strong> je cherche une voiture si vous le demandez. Selon le cas, je l’achète moi-même et vous la revends, ou je me contente d’un rôle d’intermédiaire et je perçois une commission en cas de succès. Nous convenons à l’avance de la formule applicable.</li>
            <li><strong>Véhicules sur le site :</strong> si je montre des voitures, ce sont des informations sans prix. Ce n’est pas une offre ferme et pas une vente en ligne.</li>
            </ul>

            <h3>3. Demande et achat</h3>
            <p>
            Un formulaire, un appel ou un message n’est pas encore un contrat.
            Le prix et l’achat se règlent uniquement en personne, par téléphone ou sur place.
            </p>
            <p>
            Les indications sur les véhicules du site (photos, données) sont sans engagement et peuvent changer.
            Un contrat d’achat naît uniquement hors du site.
            Il n’y a pas de vente à distance via le site.
            </p>

            <h3>4. Responsabilité</h3>
            <p>
            Je m’efforce de donner des informations justes. Je ne garantis pas que le site soit complet ou à jour.
            </p>
            <p>
            Je réponds des dommages conformément aux dispositions légales. Aucune limitation de ma responsabilité n’est prévue.
            </p>

            <h3>5. Médiation de la consommation</h3>
            <p>
            Je ne suis ni tenu ni disposé à participer à une procédure de règlement des litiges
            devant un organisme de médiation pour les consommateurs.
            </p>

            <h3>6. Protection des données</h3>
            <p>
            Les données du formulaire ou de l’e-mail servent uniquement à votre demande.
            Votre demande est conservée chez Cloudflare&nbsp;; via Discord, je reçois uniquement une notification sans vos données.
            Les détails figurent dans la <a href="/privacy">Politique de confidentialité</a>.
            </p>

            <h3>7. Dispositions finales</h3>
            <p>
            Le droit allemand s’applique. Si le client est commerçant, personne morale de droit public ou fonds
            spécial de droit public, le for est Lörrach. À l’égard des consommateurs, les fors légaux s’appliquent.
            </p>
        `,
    },

    // ========== Impressum ==========

    imprint: {
        title: "Mentions légales",
        html: `
            <p><strong>AUTO M.A.H.</strong><br>
            Propriétaire : Mohamed Ali Hussein</p>

            <p>
            Daimlerstr. 10<br>
            79585 Steinen, Allemagne
            </p>

            <p>
            Tél. : <a href="tel:+4917696084998">+49 176 96084998</a><br>
            E-mail : <a href="mailto:info@auto-mah.com">info@auto-mah.com</a>
            </p>

            <p>
            N° de TVA intracommunautaire (art. 27a loi allemande sur la TVA) :<br>
            <strong>DE402063042</strong>
            </p>

            <p>Mentions conformément à l’art. 5 de la loi allemande sur les services numériques (DDG).</p>

            <p>
            Ce site sert à prendre contact. Les contrats portant sur des véhicules ne sont pas conclus via le site.
            </p>

            <p><strong>Responsable de la publication (art. 18 (2) MStV)</strong><br>
            Mohamed Ali Hussein, Daimlerstr. 10, 79585 Steinen
            </p>

            <h3>Règlement des litiges de consommation</h3>
            <p>
            Je ne suis ni tenu ni disposé à participer à une procédure de règlement des litiges
            devant un organisme de médiation pour les consommateurs.
            </p>

            <h3>Hébergement</h3>
            <p>
            Le site est fourni par Cloudflare, Inc., 101 Townsend Street, San Francisco, CA 94107, USA
            (Cloudflare Pages). Les détails du traitement des données figurent dans la
            <a href="/privacy">Politique de confidentialité</a>.
            </p>
        `,
    },



  },
};

export default translations;
